if (typeof module !== 'undefined' && module.exports) {
  module.exports = require('./firearm-classify.js');
}

/* Firearm browse UI. Classifiers live in firearm-classify.js. Spark records unchanged. */
(function () {
  var STOP_AT = 24;
  var cfg = (typeof window !== 'undefined' && window.GPC && window.GPC.algolia) || {};
  var APP_ID = (cfg.appId || 'ZKZZ0JXNAD').trim();
  var SEARCH_KEY = (cfg.searchKey || '23c63e7556f84a79f2ad20bd9f439233').trim();
  var INDEX = (cfg.index || 'shopify_products').trim();
  var BROWSE = 'https://' + APP_ID + '-dsn.algolia.net/1/indexes/' + encodeURIComponent(INDEX) + '/browse';


  var C = (typeof window !== 'undefined' && window.GPC && window.GPC.classify) || null;
  if (!C) return;
  var PLATFORMS = C.PLATFORMS;
  var TYPES = C.TYPES;
  var CORE_TYPES = C.CORE_TYPES;
  var TYPE_MIN = C.TYPE_MIN;
  var partType = C.partType;
  var is1911Firearm = C.is1911Firearm;
  var isAr15Firearm = C.isAr15Firearm;
  var isAkFirearm = C.isAkFirearm;
  var is1022Firearm = C.is1022Firearm;
  var isAr10Firearm = C.isAr10Firearm;
  var isRemingtonFirearm = C.isRemingtonFirearm;
  var isBerettaFirearm = C.isBerettaFirearm;
  var isColtFirearm = C.isColtFirearm;
  var isGlock = C.isGlock;
  var isHk = C.isHk;
  var isMossbergFirearm = C.isMossbergFirearm;
  var isRugerFirearm = C.isRugerFirearm;
  var isSigFirearm = C.isSigFirearm;
  var isSpringfieldFirearm = C.isSpringfieldFirearm;
  var isSwFirearm = C.isSwFirearm;
  var isTaurusFirearm = C.isTaurusFirearm;
  var isCzFirearm = C.isCzFirearm;
  var isWaltherFirearm = C.isWaltherFirearm;
  var isBenelliFirearm = C.isBenelliFirearm;
  var isBersaFirearm = C.isBersaFirearm;
  var isBrowningFirearm = C.isBrowningFirearm;
  var isCanikFirearm = C.isCanikFirearm;
  var isCmmgFirearm = C.isCmmgFirearm;
  var isFnFirearm = C.isFnFirearm;
  var isHenryFirearm = C.isHenryFirearm;
  var isIwiFirearm = C.isIwiFirearm;
  var isKahrFirearm = C.isKahrFirearm;
  var isKeltecFirearm = C.isKeltecFirearm;
  var isKimberFirearm = C.isKimberFirearm;
  var isSavageFirearm = C.isSavageFirearm;
  var isTikkaFirearm = C.isTikkaFirearm;
  var isMarlinFirearm = C.isMarlinFirearm;
  var isAirgunFirearm = C.isAirgunFirearm;
  var knifeClassify = C.knifeClassify;
  var gearClassify = C.gearClassify;
  var opticBrandLabel = C.opticBrandLabel;
  var opticKindOf = C.opticKindOf;
  var magCapOf = C.magCapOf;
  var magCalOf = C.magCalOf;
  var magStyleOf = C.magStyleOf;
  var modelsOf = C.modelsOf;
  var vendorBrandKey = C.vendorBrandKey;
  var promagFitsPlatform = C.promagFitsPlatform;
  var isPartsHit = C.isPartsHit;
  var GUN_FAMILIES = C.GUN_FAMILIES || [];
  var gunFamiliesOf = C.gunFamiliesOf;
  var gunFamilyLabel = C.gunFamilyLabel || function (id) { return id || ''; };
  var glockGensOf = C.glockGensOf || function () { return []; };
  var normalizeMaker = C.normalizeMaker || function (id) { return id || null; };
  var opticSeriesOf = C.opticSeriesOf;
  var opticSeriesLabel = C.opticSeriesLabel;
  var knifeBrandLabel = C.knifeBrandLabel;
  var knifeSeriesLabel = C.knifeSeriesLabel;
  var gearCatLabel = C.gearCatLabel;
  var gearTypeLabel = C.gearTypeLabel;
  var holsterCarryOf = C.holsterCarryOf;
  var isCleanHit = C.isCleanHit;
  var skipFirearmFamily = C.skipFirearmFamily;
  var isNitrileGlove = C.isNitrileGlove;
  var colorOf = C.colorOf;
  var miscJobOf = C.miscJobOf;
  var wantsBrand = C.wantsBrand;
  var GEAR_CATS = C.GEAR_CATS || [];
  var CAL_LABELS = C.CAL_LABELS || {};
  var SPYDERCO_SERIES = C.SPYDERCO_SERIES || [];
  var KNIFE_L2 = C.KNIFE_L2 || {};
  var MAG_CALS = C.MAG_CALS || [];
  var MISC_JOBS = C.MISC_JOBS || {};
  var KNIFE_BRANDS = C.KNIFE_BRANDS || [];
  var OPTIC_SERIES = C.OPTIC_SERIES || {};

  function modelPlatform() {
    if (handle === 'parts' && state && state.gun && PLATFORMS[state.gun]) return PLATFORMS[state.gun];
    return platform;
  }

  function firearmModelLabel(id) {
    var plat = modelPlatform();
    var labels = (plat && plat.modelLabels) || {};
    if (labels[id]) return labels[id];
    if (plat && plat.parse === 'glock') return /^G/i.test(id) ? id : 'G' + id;
    if (/^\d/.test(id) || id === '43X') return 'Model ' + id;
    return id;
  }

  function hitModels(h) {
    if (handle === 'parts') {
      if (!state.gun || !h.modelsByGun) return [];
      return h.modelsByGun[state.gun] || [];
    }
    return h.models || [];
  }

  function normalizeType(id) {
    if (!id || !platform || !platform.mergeTypes) return id;
    return platform.mergeTypes[id] || id;
  }

  function remapRetiredOpticType() {
    if (!(platform && platform.lockedCat === 'optics' && state.type === 'holosun')) return;
    state.type = 'red-dots';
    if (!state.brand) state.brand = 'holosun';
  }

  function usesFamilyCatalog() {
    return kind === 'firearm' && handle !== 'parts';
  }

  // Gun pages: load the manufacturer family once a model is chosen so type
  // cards/counts match that model. Type-first stays for All + a part type
  // (Glock magazines) and for /pages/parts.
  function loadFamilyHits() {
    if (!usesFamilyCatalog()) return false;
    if (hasModelStep() && !state.model && !state.type) return false;
    if (state.type && (!state.model || state.model === 'all')) return false;
    return true;
  }

  function typeHidden(id) {
    if (!id || !platform) return false;
    if (platform.hideTypes && platform.hideTypes[id]) return true;
    var model = state && state.model;
    if (model && model !== 'all' && platform.hideTypesByModel &&
        platform.hideTypesByModel[model] && platform.hideTypesByModel[model][id]) {
      return true;
    }
    return false;
  }

  function snapshotTypeRows() {
    var rows;
    if (state.model && state.model !== 'all') {
      rows = (indexPlat && indexPlat.typesByModel && indexPlat.typesByModel[state.model]) || [];
    } else {
      rows = (indexPlat && indexPlat.types) || [];
    }
    rows = rows.filter(function (b) { return b && b.id && !typeHidden(b.id); });
    var prefer = (platform.preferTypesByModel && state.model && platform.preferTypesByModel[state.model]) || platform.preferTypes || [];
    if (prefer.length) {
      rows = rows.slice().sort(function (a, b) {
        var ai = prefer.indexOf(a.id);
        var bi = prefer.indexOf(b.id);
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });
    }
    return rows;
  }

  function normalizeGun(id) {
    if (!id) return null;
    var i;
    for (i = 0; i < GUN_FAMILIES.length; i++) {
      if (GUN_FAMILIES[i].id === id) return id;
    }
    return null;
  }

  function normalizeGen(id) {
    if (!id) return null;
    var n = String(id).replace(/^gen-?/i, '');
    if (/^[1-6]$/.test(n)) return n;
    return null;
  }

  function showGenFilter() {
    if (state.type !== 'triggers') return false;
    return handle === 'glock' || state.gun === 'glock';
  }

  function typeLabelOf(id) {
    if (!id) return '';
    if (platform && platform.typeLabels && platform.typeLabels[id]) return platform.typeLabels[id];
    var t = TYPES.find(function (x) { return x.id === id; });
    return t ? t.label : id;
  }
  var handle, platform, kind, items, params, state, indexPlat;
  var cardsEl, crumbsEl, backEl, statusEl, resultsEl, hitsEl, statsEl, nameEl, wrapEl;
  var productPool = [];
  var PAGE_SIZE = 48;
  var shownCap = PAGE_SIZE;
  var loadedKey = null;
  var catalogLoadId = 0;
  if (typeof window !== 'undefined') {
    handle = (window.GPC_FIREARM || '').replace(/^\/pages\//, '').replace(/\/$/, '');
    platform = PLATFORMS[handle];
    if (!platform) return;
    kind = platform.kind || 'firearm';

    items = [];
    indexPlat = null;
    params = new URLSearchParams(window.location.search);
    state = {
      model: params.get('model') || (kind === 'firearm' && platform.models && platform.models.length ? null : (kind === 'firearm' ? 'all' : null)),
      type: normalizeType(params.get('type')) || null,
      brand: normalizeMaker(params.get('brand')),
      series: params.get('series') || null,
      cat: params.get('cat') || platform.lockedCat || null,
      fGroup: params.get('group') || null,
      fMaker: normalizeMaker(params.get('maker')),
      fColor: params.get('color') || null,
      fCap: params.get('cap') || null,
      fCal: params.get('cal') || null,
      fStyle: params.get('style') || null,
      fCarry: params.get('carry') || null,
      fJob: params.get('job') || null,
      inStock: params.get('stock') !== '0' && params.get('stock') !== 'all',
      sort: params.get('sort') === 'hi' || params.get('sort') === 'lo' ? params.get('sort') : '',
      fBlade: params.get('blade') || null,
      gun: normalizeGun(params.get('gun')),
      gen: normalizeGen(params.get('gen'))
    };
    remapRetiredOpticType();
    if (state.type && kind === 'firearm' && platform.models && platform.models.length && !state.model) {
      state.model = 'all';
    }
    if (handle === 'parts' && (!state.gun || !modelPlatform() || !modelPlatform().models || !modelPlatform().models.length)) {
      if (state.model && state.model !== 'all') state.model = 'all';
    }

    cardsEl = document.getElementById('gpc-firearm-cards');
    crumbsEl = document.getElementById('gpc-firearm-crumbs');
    backEl = document.getElementById('gpc-firearm-back');
    statusEl = document.getElementById('gpc-firearm-status');
    resultsEl = document.getElementById('gpc-firearm-results');
    hitsEl = document.getElementById('gpc-firearm-hits');
    statsEl = document.getElementById('gpc-firearm-stats');
    nameEl = document.getElementById('gpc-firearm-name');
    wrapEl = document.getElementById('gpc-firearm-browse');
    if (!cardsEl) return;
  }

  function hasModelStep() {
    return kind === 'firearm' && platform.models && platform.models.length;
  }

  function hasHeaderFilters() {
    return kind === 'firearm' || kind === 'knives' || kind === 'gear';
  }

  function headerFilterIds() {
    if (kind === 'knives') return ['brand', 'model'];
    if (kind === 'gear') {
      if (platform.lockedCat) return ['type', 'brand'];
      return ['cat', 'type', 'brand'];
    }
    if (handle === 'parts') {
      var ids = ['type', 'gun'];
      var gplat = modelPlatform();
      if (gplat && gplat.models && gplat.models.length) ids.push('model');
      if (showGenFilter()) ids.push('gen');
      ids.push('brand');
      return ids;
    }
    var ids = ['type'];
    if (platform.models && platform.models.length) ids.push('model');
    if (showGenFilter()) ids.push('gen');
    ids.push('brand');
    return ids;
  }

  function headerFilterPlaceholder(id) {
    var labels = (platform && platform.headerFilterLabels) || {};
    if (labels[id]) return labels[id];
    if (id === 'cat') return 'Category';
    if (id === 'type') return 'Type';
    if (id === 'brand') return 'Brand';
    if (id === 'gun') return 'Gun';
    if (id === 'gen') return 'Gen';
    if (id === 'model') {
      if (kind === 'knives') return 'Series';
      var plat = modelPlatform();
      if (handle === 'ar-15' || (plat && plat.parse === 'ar15')) return 'Caliber / size';
      return 'Model';
    }
    return 'Filter';
  }

  function browsePath() {
    var u = new URL(window.location.href);
    u.search = '';
    if (kind === 'knives') {
      if (state.brand) u.searchParams.set('brand', state.brand);
      if (state.series) u.searchParams.set('series', state.series);
    } else if (kind === 'gear') {
      if (state.cat && !platform.lockedCat) u.searchParams.set('cat', state.cat);
      if (state.type) u.searchParams.set('type', state.type);
      if (state.brand) u.searchParams.set('brand', state.brand);
      if (state.series) u.searchParams.set('series', state.series);
    } else {
      if (state.model && !(hasHeaderFilters() && state.model === 'all')) {
        if (state.model) u.searchParams.set('model', state.model);
      }
      if (state.type) u.searchParams.set('type', state.type);
      if (state.gun) u.searchParams.set('gun', state.gun);
      if (state.gen) u.searchParams.set('gen', state.gen);
      if (state.brand && state.brand !== 'all') u.searchParams.set('brand', state.brand);
    }
    if (state.fGroup) u.searchParams.set('group', state.fGroup);
    if (state.fMaker) u.searchParams.set('maker', state.fMaker);
    if (state.fColor) u.searchParams.set('color', state.fColor);
    if (state.fCap) u.searchParams.set('cap', state.fCap);
    if (state.fCal) u.searchParams.set('cal', state.fCal);
    if (state.fStyle) u.searchParams.set('style', state.fStyle);
    if (state.fCarry) u.searchParams.set('carry', state.fCarry);
    if (state.fJob) u.searchParams.set('job', state.fJob);
    if (!state.inStock) u.searchParams.set('stock', '0');
    if (state.sort) u.searchParams.set('sort', state.sort);
    if (state.fBlade) u.searchParams.set('blade', state.fBlade);
    return u.pathname + u.search + u.hash;
  }

  function previewHref(apply) {
    var snap = {
      model: state.model,
      type: state.type,
      brand: state.brand,
      series: state.series,
      cat: state.cat,
      gun: state.gun,
      gen: state.gen
    };
    apply(state);
    var href = browsePath();
    state.model = snap.model;
    state.type = snap.type;
    state.brand = snap.brand;
    state.series = snap.series;
    state.cat = snap.cat;
    state.gun = snap.gun;
    state.gen = snap.gen;
    return href;
  }

  function seeMoreLabel(title) {
    var t = String(title || '').trim();
    if (!t) return 'See more';
    if (t === 'BCGs') return 'See more BCGs';
    if (t === 'Magazine Holster') return 'See more magazine holsters';
    if (/^Model\s/i.test(t) || /^G\d/i.test(t)) return 'See more ' + t;
    if (/^All\s+/i.test(t)) return 'See more ' + t.replace(/^All\s+/i, '');
    if (/\bparts\b|\bknives\b|\bgear\b|\blights\b|\bbags\b|\bmuffs\b/i.test(t) || /s$/i.test(t)) {
      return 'See more ' + t.toLowerCase();
    }
    return 'See more ' + t;
  }

  function clickHereLead(title) {
    var t = String(title || '').trim();
    if (!t) return 'Click here';
    if (t === 'BCGs') return 'Click here for BCGs';
    if (t === 'Magazine Holster') return 'Click here for magazine holsters';
    if (/^All\s+/i.test(t)) return 'Click here for ' + t.replace(/^All\s+/i, '');
    if (/^Model\s/i.test(t) || /^G\d/i.test(t)) return 'Click here for ' + t + ' parts';
    if (/\bparts\b|\bknives\b|\bgear\b|\blights\b|\bbags\b|\bmuffs\b/i.test(t) || /s$/i.test(t)) {
      return 'Click here for ' + t.toLowerCase();
    }
    return 'Click here for ' + t + ' parts';
  }

  function joinPhrase(items) {
    items = (items || []).filter(Boolean);
    if (!items.length) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return items[0] + ' and ' + items[1];
    return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
  }

  function rankedIds(counts, max, min) {
    min = min || 1;
    return Object.keys(counts || {}).filter(function (k) {
      return k && k !== 'other' && k !== 'all' && counts[k] >= min;
    }).sort(function (a, b) {
      return counts[b] - counts[a];
    }).slice(0, max);
  }

  function isTypeKey(id) {
    var i;
    if (!id) return false;
    for (i = 0; i < TYPES.length; i++) {
      if (TYPES[i].id === id) return true;
    }
    return false;
  }

  function previewCaption(row, hits) {
    hits = hits || [];
    var n = hits.length;
    var min = n < 12 ? 1 : 2;
    var brandCounts = {};
    var brandHit = {};
    var typeCounts = {};
    var capCounts = {};
    var calCounts = {};
    var carryCounts = {};
    var modelCounts = {};
    var seriesCounts = {};
    var i, j, h, bk, cap, cal, cy;
    for (i = 0; i < n; i++) {
      h = hits[i];
      bk = makerKeyOf(h);
      if (bk) {
        brandCounts[bk] = (brandCounts[bk] || 0) + 1;
        if (!brandHit[bk]) brandHit[bk] = h;
      }
      if (h.ptype) typeCounts[h.ptype] = (typeCounts[h.ptype] || 0) + 1;
      if (h.gtype) typeCounts[h.gtype] = (typeCounts[h.gtype] || 0) + 1;
      cap = magCapOf(h.title);
      if (cap) capCounts[cap] = (capCounts[cap] || 0) + 1;
      cal = magCalOf(h.title);
      if (cal) calCounts[cal] = (calCounts[cal] || 0) + 1;
      cy = holsterCarryOf(h.title);
      if (cy) carryCounts[cy] = (carryCounts[cy] || 0) + 1;
      if (h.kseries) seriesCounts[h.kseries] = (seriesCounts[h.kseries] || 0) + 1;
      if (h.models) {
        for (j = 0; j < h.models.length; j++) {
          modelCounts[h.models[j]] = (modelCounts[h.models[j]] || 0) + 1;
        }
      }
    }

    var bits = [];
    var key = row.key;
    var typeLayer = isTypeKey(key);

    if (kind === 'knives' && !state.brand) {
      bits.push(joinPhrase(rankedIds(seriesCounts, 5, min).map(function (id) {
        return knifeSeriesLabel(key, id);
      })));
    } else if (!typeLayer) {
      bits.push(joinPhrase(rankedIds(typeCounts, 5, min).map(function (id) {
        var label = kind === 'gear'
          ? (gearTypeLabel(state.cat, id) || typeLabelOf(id) || id)
          : (typeLabelOf(id) || id);
        return String(label).toLowerCase();
      })));
      if (kind === 'knives') {
        bits.push(joinPhrase(rankedIds(seriesCounts, 5, min).map(function (id) {
          return knifeSeriesLabel(state.brand || key, id);
        })));
      }
    } else {
      bits.push(joinPhrase(rankedIds(brandCounts, 5, min).map(function (id) {
        return makerLabelOf(brandHit[id]);
      })));
    }

    if (key === 'magazines' || (!state.type && (typeCounts.magazines || 0) >= min && !typeLayer)) {
      bits.push(joinPhrase(Object.keys(capCounts).filter(function (k) {
        return capCounts[k] >= min;
      }).sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      }).slice(0, 5).map(function (c) {
        return c + '-round';
      })));
      bits.push(joinPhrase(rankedIds(calCounts, 4, min).map(function (id) {
        return CAL_LABELS[id] || id;
      })));
    }

    if (key === 'holsters') {
      bits.push(joinPhrase(['iwb', 'aiwb', 'owb'].filter(function (id) {
        return (carryCounts[id] || 0) >= min;
      }).map(function (id) {
        return CARRY_LABELS[id];
      })));
    }

    if (kind === 'firearm' && platform && platform.models && typeLayer) {
      bits.push((function () {
        var mods = platform.models.filter(function (id) {
          return (modelCounts[id] || 0) >= min;
        }).slice(0, 8).map(function (id) {
          return firearmModelLabel(id);
        });
        return mods.length ? 'Fits ' + joinPhrase(mods) : '';
      })());
    }

    var text = bits.filter(Boolean).join('. ');
    if (text && !/\.$/.test(text)) text += '.';
    if (text) return text + ' Live supplier inventory.';
    if (row.sub) return String(row.sub).replace(/\s—\s.*$/, '') + '. Live supplier inventory.';
    return 'Live supplier inventory. Tap through for in-stock parts.';
  }

  function readStateFromUrl() {
    var p = new URLSearchParams(window.location.search);
    state.brand = normalizeMaker(p.get('brand'));
    state.series = p.get('series') || null;
    state.cat = p.get('cat') || platform.lockedCat || null;
    state.model = p.get('model') || (kind === 'firearm' ? (hasModelStep() ? null : 'all') : null);
    state.type = normalizeType(p.get('type')) || null;
    remapRetiredOpticType();
    state.gun = normalizeGun(p.get('gun'));
    state.gen = normalizeGen(p.get('gen'));
    if (state.type && hasModelStep() && !state.model) state.model = 'all';
    if (handle === 'parts' && (!state.gun || !modelPlatform() || !modelPlatform().models || !modelPlatform().models.length)) {
      if (state.model && state.model !== 'all') state.model = 'all';
    }
    if (state.cat === 'range' && (state.type === 'hearing' || state.type === 'eyes' || state.type === 'over-ear' || state.type === 'in-ear' || state.type === 'over-ear-elec' || state.type === 'over-ear-passive')) {
      state.cat = state.type === 'eyes' ? 'eyes' : 'hearing';
    }
    if (state.cat === 'protection') {
      if (state.type === 'eyes' || state.type === 'glasses' || state.type === 'goggles') {
        state.cat = 'eyes';
        if (state.type === 'eyes') state.type = null;
      } else {
        state.cat = 'hearing';
      }
    }
    state.fGroup = p.get('group') || null;
    state.fMaker = normalizeMaker(p.get('maker'));
    state.fColor = p.get('color') || null;
    state.fCap = p.get('cap') || null;
    state.fCal = p.get('cal') || null;
    state.fStyle = p.get('style') || null;
    state.fCarry = p.get('carry') || null;
    state.fJob = p.get('job') || null;
    state.inStock = p.get('stock') !== '0' && p.get('stock') !== 'all';
    state.sort = p.get('sort') === 'hi' || p.get('sort') === 'lo' ? p.get('sort') : '';
    state.fBlade = p.get('blade') || null;
  }

  function clearProductFilters() {
    state.fGroup = null;
    state.fMaker = null;
    state.fColor = null;
    state.fCap = null;
    state.fCal = null;
    state.fStyle = null;
    state.fCarry = null;
    state.fJob = null;
    state.inStock = true;
    state.sort = '';
    state.fBlade = null;
  }

  function depth() {
    if (kind === 'knives') return (state.brand ? 1 : 0) + (state.series ? 1 : 0);
    if (kind === 'gear') {
      if (platform.lockedCat) return (state.type ? 1 : 0) + (state.brand ? 1 : 0) + (state.series ? 1 : 0);
      return (state.cat ? 1 : 0) + (state.type ? 1 : 0) + (state.brand ? 1 : 0) + (state.series ? 1 : 0);
    }
    return (hasModelStep() && state.model ? 1 : 0) + (state.type ? 1 : 0) + (state.gun ? 1 : 0) + (state.brand ? 1 : 0);
  }

  var lastTrackedPath = '';

  function trackBrowse() {
    var path = browsePath();
    if (path === lastTrackedPath) return;
    lastTrackedPath = path;
    var payload = {
      event: 'gpc_browse',
      page_path: path,
      page_location: window.location.origin + path,
      browse_kind: kind,
      browse_handle: handle,
      browse_cat: state.cat || '',
      browse_type: state.type || '',
      browse_brand: state.brand || '',
      browse_model: state.model || '',
      browse_gun: state.gun || '',
      browse_series: state.series || '',
      browse_depth: depth()
    };
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: path,
          page_location: window.location.origin + path
        });
        window.gtag('event', 'gpc_browse', {
          browse_kind: kind,
          browse_handle: handle,
          browse_cat: payload.browse_cat,
          browse_type: payload.browse_type,
          browse_brand: payload.browse_brand,
          browse_model: payload.browse_model,
          browse_series: payload.browse_series
        });
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('gpc_browse', payload);
      }
    } catch (e) {}
  }

  function jumpBrowseTop() {
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }

  function commit(push, keepFilters) {
    if (!keepFilters) clearProductFilters();
    var url = browsePath();
    var data = { gpcBrowse: true, gpcDepth: depth() };
    if (push) history.pushState(data, '', url);
    else history.replaceState(data, '', url);
    trackBrowse();
    ensureCatalog();
    if (hasHeaderFilters() || !keepFilters) {
      jumpBrowseTop();
      requestAnimationFrame(jumpBrowseTop);
    }
  }

  function goUp() {
    if (depth() === 0) {
      window.location.href = '/';
      return;
    }
    if (history.state && history.state.gpcBrowse && history.state.gpcDepth > 0) {
      history.back();
      return;
    }
    if (kind === 'knives') {
      if (state.series) state.series = null;
      else state.brand = null;
    } else if (kind === 'gear') {
      if (state.series) state.series = null;
      else if (state.brand) state.brand = null;
      else if (state.type) state.type = null;
      else if (!platform.lockedCat) state.cat = null;
    } else if (state.brand) {
      state.brand = null;
    } else if (handle === 'parts' && state.model && state.model !== 'all') {
      state.model = 'all';
    } else if (state.gun) {
      state.gun = null;
      if (handle === 'parts') state.model = 'all';
    } else if (state.type) {
      state.type = null;
    } else if (hasModelStep()) {
      state.model = null;
    }
    commit(false);
  }

  if (typeof window !== 'undefined') {
    if (backEl) backEl.addEventListener('click', goUp);
    window.addEventListener('popstate', function () {
      readStateFromUrl();
      trackBrowse();
      ensureCatalog();
      jumpBrowseTop();
    });
    window.addEventListener('resize', syncHeaderOffset);
  }

  function needsBodyHtml() {
    if (kind === 'knives') return true;
    if (loadFamilyHits()) return true;
    var t = state.type;
    return t === 'triggers' || t === 'recoil' || t === 'internals' || t === 'springs' || t === 'safeties';
  }

  function typeQueries(typeId) {
    var map = {
      magazines: ['MAG', 'magazine', 'PMAG'],
      'mag-extensions': ['MAG EXT', 'extension', 'spacer', 'X-Grip'],
      holsters: ['holster', 'IWB', 'OWB', 'HLSTR'],
      pouches: ['pouch', 'PCH', 'carrier'],
      triggers: ['trigger'],
      stocks: ['stock', 'STK'],
      grips: ['grip'],
      sights: ['sight', 'tritium'],
      'red-dots': ['RMR', 'SRO', 'red dot'],
      plates: ['plate', 'MOS', 'RMR'],
      barrels: ['barrel', 'BBL'],
      bcg: ['BCG', 'bolt carrier'],
      handguards: ['handguard'],
      lights: ['light', 'laser', 'TLR'],
      slides: ['slide'],
      mounts: ['mount'],
      compensators: ['compensator', 'brake', 'flash hider'],
      'charging-handles': ['charging handle'],
      'buffer-tubes': ['buffer tube'],
      forends: ['forend', 'forearm'],
      recoil: ['recoil', 'guide rod'],
      magwells: ['magwell'],
      loaders: ['loader', 'Uplula']
    };
    if (!typeId) return [];
    return map[typeId] || [String(typeId).replace(/-/g, ' ')];
  }

  function catalogKey() {
    if (kind === 'knives') return 'knives';
    if (kind === 'gear') {
      if (platform.lockedCat) return 'optics:' + (state.type || '');
      return 'gear:' + (state.cat || '') + ':' + (state.type || '');
    }
    if (handle === 'parts') return 'parts:' + (state.type || '');
    if (loadFamilyHits()) return handle;
    if (usesFamilyCatalog() && hasModelStep() && !state.model && !state.type) return handle + ':models';
    return handle + ':' + (state.type || '');
  }

  function catalogQueries() {
    if (kind === 'knives') return platform.queries || [''];
    if (kind === 'gear') {
      if (platform.lockedCat === 'optics') {
        if (!state.type) return [];
        var opticQ = {
          'red-dots': ['red dot', 'reflex', 'RMR', 'T2', 'Holosun'],
          scopes: ['scope', 'LPVO', 'riflescope'],
          spotting: ['spotting'],
          binoculars: ['binocular'],
          magnifiers: ['magnifier'],
          'weapon-lights': ['weapon light', 'WML', 'TLR'],
          'bore-sighters': ['bore sighter'],
          rangefinders: ['rangefinder'],
          thermal: ['thermal'],
          lasers: ['laser'],
          rings: ['rings'],
          mounts: ['mount'],
          plates: ['plate', 'MOS', 'RMR'],
          accessories: ['cap', 'cover', 'battery']
        };
        return opticQ[state.type] || typeQueries(state.type);
      }
      if (!state.cat) return [];
      var gearCat = null;
      (GEAR_CATS || []).forEach(function (c) { if (c.id === state.cat) gearCat = c; });
      if (!state.type && !(gearCat && gearCat.skipL2)) return [];
      var gearQ = {
        storage: ['case', 'bag'],
        cleaning: ['cleaning', 'solvent', 'bore'],
        lights: ['flashlight'],
        hearing: ['muff', 'earplug', 'hearing'],
        eyes: ['glasses', 'goggle'],
        slings: ['sling'],
        range: ['target'],
        med: ['ifak', 'tourniquet', 'first aid'],
        bipods: ['bipod'],
        gloves: ['glove'],
        loaders: ['loader', 'uplula'],
        carriers: ['pouch', 'taco'],
        batteries: ['battery'],
        locks: ['gun lock', 'cable lock'],
        defense: ['pepper', 'stun']
      };
      if (state.type) return gearQ[state.cat] || typeQueries(state.type);
      return gearQ[state.cat] || [String(state.cat).replace(/-/g, ' ')];
    }
    if (loadFamilyHits()) return (platform.queries && platform.queries.length) ? platform.queries : [''];
    if (handle === 'parts' || usesFamilyCatalog()) {
      if (!state.type) return [];
      return typeQueries(state.type);
    }
    return (platform.queries && platform.queries.length) ? platform.queries : [''];
  }

  function browseQuery(query) {
    var acc = [];
    var withBody = needsBodyHtml();
    function step(cursor) {
      var body = {
        query: query,
        hitsPerPage: 1000,
        typoTolerance: false,
        analytics: false,
        attributesToRetrieve: withBody
          ? ['title', 'vendor', 'handle', 'image', 'price', 'objectID', 'inventory_available', 'body_html_safe', 'product_type']
          : ['title', 'vendor', 'handle', 'image', 'price', 'objectID', 'inventory_available', 'product_type']
      };
      if (cursor) body.cursor = cursor;
      return fetch(BROWSE, {
        method: 'POST',
        headers: {
          'X-Algolia-Application-Id': APP_ID,
          'X-Algolia-API-Key': SEARCH_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (data) {
        acc = acc.concat(data.hits || []);
        if (data.cursor) return step(data.cursor);
        return acc;
      });
    }
    return step(null);
  }

  function hitHasModel(h, model) {
    if (!model || model === 'all') return true;
    var mods = hitModels(h);
    if (mods.indexOf(model) !== -1) return true;
    if (model === '700') return mods.indexOf('700SA') !== -1 || mods.indexOf('700LA') !== -1;
    return false;
  }

  function filtered() {
    return items.filter(function (h) {
      if (kind === 'knives') {
        if (state.brand && state.brand !== 'all' && h.kbrand !== state.brand) return false;
        if (state.series && state.series !== 'all' && h.kseries !== state.series) return false;
        return true;
      }
      if (kind === 'gear') {
        if (state.cat && h.gcat !== state.cat) return false;
        if (state.type === 'hearing') {
          if (h.gtype !== 'over-ear-elec' && h.gtype !== 'over-ear-passive' && h.gtype !== 'in-ear') return false;
        } else if (state.type === 'over-ear') {
          if (h.gtype !== 'over-ear-elec' && h.gtype !== 'over-ear-passive') return false;
        } else if (state.type && h.gtype !== state.type) return false;
        if (state.brand && state.brand !== 'all') {
          if ((h.gbrand || vendorBrandKey(h.vendor)) !== state.brand) return false;
        }
        if (state.series && state.series !== 'all' && h.gseries !== state.series) return false;
        return true;
      }
      if (state.model && state.model !== 'all' && !hitHasModel(h, state.model)) return false;
      if (state.type && h.ptype !== state.type) return false;
      if (state.gun && (!h.guns || h.guns.indexOf(state.gun) === -1)) return false;
      if (state.gen && h.gens && h.gens.length && h.gens.indexOf(state.gen) === -1) return false;
      if (state.brand && state.brand !== 'all') {
        var fb = h.fbrand || vendorBrandKey(h.vendor);
        if (fb !== state.brand) return false;
      }
      return true;
    });
  }

  var headerPoolCache = { key: '', pools: {} };
  function headerFilterPool(except) {
    var key = [kind, state.cat || '', state.type || '', state.model || '', state.brand || '', state.series || '', state.gun || '', state.gen || '', items.length].join('\0');
    if (headerPoolCache.key !== key) {
      headerPoolCache = { key: key, pools: {} };
    }
    if (headerPoolCache.pools[except]) return headerPoolCache.pools[except];
    var pool = items.filter(function (h) {
      if (kind === 'knives') {
        if (except !== 'brand' && state.brand && state.brand !== 'all' && h.kbrand !== state.brand) return false;
        if (except !== 'model' && state.series && state.series !== 'all' && h.kseries !== state.series) return false;
        return true;
      }
      if (kind === 'gear') {
        if (except !== 'cat' && state.cat && h.gcat !== state.cat) return false;
        if (except !== 'type' && state.type && h.gtype !== state.type) {
          if (state.type === 'hearing') {
            if (h.gtype !== 'over-ear-elec' && h.gtype !== 'over-ear-passive' && h.gtype !== 'in-ear') return false;
          } else if (h.gtype !== state.type) return false;
        }
        if (except !== 'brand' && state.brand && state.brand !== 'all') {
          if ((h.gbrand || vendorBrandKey(h.vendor)) !== state.brand) return false;
        }
        return true;
      }
      if (except !== 'model' && state.model && state.model !== 'all' && !hitHasModel(h, state.model)) return false;
      if (except !== 'type' && state.type && h.ptype !== state.type) return false;
      if (except !== 'gun' && state.gun && (!h.guns || h.guns.indexOf(state.gun) === -1)) return false;
      if (except !== 'gen' && state.gen && h.gens && h.gens.length && h.gens.indexOf(state.gen) === -1) return false;
      if (except !== 'brand' && state.brand && state.brand !== 'all') {
        var fb = h.fbrand || vendorBrandKey(h.vendor);
        if (fb !== state.brand) return false;
      }
      return true;
    });
    headerPoolCache.pools[except] = pool;
    return pool;
  }

  function headerTypeOpts() {
    if ((!items || !items.length) && indexPlat) {
      var snap = snapshotTypeRows();
      if (snap.length) return snap.map(function (r) { return { id: r.id, label: r.label }; });
    }
    var rows = [];
    var seen = {};
    if (kind === 'gear') {
      var cat = GEAR_CATS.filter(function (c) { return c.id === (state.cat || platform.lockedCat); })[0];
      var types = (cat && cat.l2) || [];
      if (platform.quickTypes && platform.quickTypes.length) {
        types = platform.quickTypes.map(function (id) {
          var t = types.filter(function (x) { return x.id === id; })[0];
          return t || { id: id, label: gearTypeLabel(state.cat || platform.lockedCat, id) || id };
        });
      }
      var tc = {};
      headerFilterPool('type').forEach(function (h) { tc[h.gtype] = (tc[h.gtype] || 0) + 1; });
      types.forEach(function (t) {
        if (!tc[t.id] || seen[t.id]) return;
        seen[t.id] = 1;
        rows.push({ id: t.id, label: t.label || gearTypeLabel(state.cat || platform.lockedCat, t.id) || t.id });
      });
      return rows;
    }
    var tc2 = {};
    headerFilterPool('type').forEach(function (h) { tc2[h.ptype] = (tc2[h.ptype] || 0) + 1; });
    function take(id) {
      if (!id || seen[id] || !tc2[id]) return;
      if (typeHidden(id)) return;
      seen[id] = 1;
      rows.push({ id: id, label: typeLabelOf(id) });
    }
    (platform.quickTypes || []).forEach(take);
    TYPES.forEach(function (t) {
      if (CORE_TYPES[t.id] || (tc2[t.id] || 0) >= TYPE_MIN) take(t.id);
    });
    return rows;
  }

  function headerCatOpts() {
    if ((!items || !items.length) && indexPlat && indexPlat.cats && indexPlat.cats.length) {
      return indexPlat.cats.map(function (r) { return { id: r.id, label: r.label }; });
    }
    var counts = {};
    headerFilterPool('cat').forEach(function (h) {
      if (h.gcat) counts[h.gcat] = (counts[h.gcat] || 0) + 1;
    });
    return GEAR_CATS.filter(function (c) {
      if (c.skipOnGear && !platform.lockedCat) return false;
      return (counts[c.id] || 0) > 0;
    }).map(function (c) {
      return { id: c.id, label: c.label };
    });
  }

  function headerModelOpts() {
    if ((!items || !items.length) && kind !== 'knives' && indexPlat && indexPlat.models && indexPlat.models.length) {
      return indexPlat.models.map(function (r) { return { id: r.id, label: r.label }; });
    }
    if (kind === 'knives') {
      if (!state.brand || state.brand === 'all') return [];
      var series = state.brand === 'spyderco' ? SPYDERCO_SERIES : (KNIFE_L2[state.brand] || []);
      var sc = {};
      headerFilterPool('model').forEach(function (h) {
        if (h.kseries) sc[h.kseries] = (sc[h.kseries] || 0) + 1;
      });
      return series.filter(function (s) { return (sc[s.id] || 0) > 0; }).map(function (s) {
        return { id: s.id, label: s.label };
      });
    }
    var plat = modelPlatform();
    var modelIds = (plat && plat.models) || [];
    if (!modelIds.length) return [];
    var counts = {};
    modelIds.forEach(function (id) { counts[id] = 0; });
    headerFilterPool('model').forEach(function (h) {
      hitModels(h).forEach(function (id) {
        if (counts[id] !== undefined) counts[id] += 1;
      });
    });
    var rows = modelIds.filter(function (id) { return counts[id] > 0; }).map(function (id) {
      return { id: id, label: firearmModelLabel(id) };
    });
    if (!rows.length && !items.length) {
      return modelIds.map(function (id) {
        return { id: id, label: firearmModelLabel(id) };
      });
    }
    return rows;
  }

  function headerBrandOpts() {
    if ((!items || !items.length) && indexPlat && indexPlat.brands && indexPlat.brands.length) {
      return indexPlat.brands.map(function (r) { return { id: r.id, label: r.label }; });
    }
    var counts = {};
    var labels = {};
    headerFilterPool('brand').forEach(function (h) {
      var id;
      var label;
      if (kind === 'knives') {
        id = h.kbrand;
        if (!id) return;
        label = knifeBrandLabel(id);
      } else if (kind === 'gear') {
        id = h.gbrand || vendorBrandKey(h.vendor);
        if (!id || id === 'other') return;
        label = opticBrandLabel(id, h.vendor);
      } else {
        id = h.fbrand || vendorBrandKey(h.vendor);
        if (!id || id === 'other') return;
        label = opticBrandLabel(id, h.vendor);
      }
      counts[id] = (counts[id] || 0) + 1;
      if (!labels[id]) labels[id] = label;
    });
    return Object.keys(counts).filter(function (id) {
      return counts[id] >= 2;
    }).sort(function (a, b) {
      return String(labels[a] || a).localeCompare(String(labels[b] || b), undefined, { sensitivity: 'base' });
    }).map(function (id) {
      return { id: id, label: labels[id] };
    });
  }

  function headerGunOpts() {
    if ((!items || !items.length) && indexPlat && indexPlat.guns && indexPlat.guns.length) {
      return indexPlat.guns.map(function (r) { return { id: r.id, label: r.label }; });
    }
    var counts = {};
    headerFilterPool('gun').forEach(function (h) {
      (h.guns || []).forEach(function (id) {
        if (!id) return;
        counts[id] = (counts[id] || 0) + 1;
      });
    });
    return GUN_FAMILIES.filter(function (g) {
      return (counts[g.id] || 0) >= 2;
    }).map(function (g) {
      return { id: g.id, label: g.label };
    });
  }

  function headerGenOpts() {
    var counts = {};
    headerFilterPool('gen').forEach(function (h) {
      (h.gens || []).forEach(function (id) {
        if (!id) return;
        counts[id] = (counts[id] || 0) + 1;
      });
    });
    return ['3', '4', '5', '6', '1', '2'].filter(function (id) {
      return (counts[id] || 0) >= 1;
    }).map(function (id) {
      return { id: id, label: 'Gen ' + id };
    });
  }

  var hfBound = false;
  function bindHeaderFilters() {
    var root = document.getElementById('gpc-browse-jump');
    if (!root || hfBound) return;
    hfBound = true;
    function applyHeaderFilter(id, val) {
      if (id === 'cat') {
        state.cat = val;
        state.type = null;
        state.brand = null;
        state.series = null;
      } else if (id === 'type') {
        state.type = val;
        if (val !== 'triggers') state.gen = null;
      } else if (id === 'gun') {
        state.gun = val;
        if (handle === 'parts') state.model = 'all';
        if (val !== 'glock') state.gen = null;
      } else if (id === 'gen') state.gen = normalizeGen(val);
      else if (id === 'model') {
        if (kind === 'knives') state.series = val;
        else state.model = val;
      } else if (id === 'brand') {
        state.brand = val;
        if (kind === 'knives') state.series = null;
      }
      else {
        setFacetValue(id, val);
        commit(true, true);
        return;
      }
      commit(true);
    }
    root.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-hf]');
      if (!sel) return;
      applyHeaderFilter(sel.getAttribute('data-hf'), sel.value || null);
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-hf-clear-all]')) {
        state.type = null;
        state.model = null;
        state.brand = null;
        state.series = null;
        state.gun = null;
        state.gen = null;
        if (kind === 'gear' && !platform.lockedCat) state.cat = null;
        clearProductFilters();
        commit(true);
        return;
      }
      var btn = e.target.closest && e.target.closest('[data-hf-clear]');
      if (!btn) return;
      applyHeaderFilter(btn.getAttribute('data-hf-clear'), null);
    });
  }

  function filterWidget(id, placeholder, value, options) {
    var on = !!(value && value !== 'all');
    var current = '';
    if (on) {
      options.forEach(function (o) { if (o.id === value) current = o.label; });
      if (!current) current = value;
    }
    var html = '<div class="gpc-home-jump' + (on ? ' is-on' : '') + '" data-filter="' + id + '">';
    html += '<label class="gpc-sr" for="gpc-hf-' + id + '">' + escHtml(placeholder) + '</label>';
    html += '<select id="gpc-hf-' + id + '" class="gpc-home-jump-select" data-hf="' + id + '">';
    html += '<option value="">' + escHtml(placeholder) + '</option>';
    options.forEach(function (o) {
      html += '<option value="' + escAttr(o.id) + '"' + (o.id === value ? ' selected' : '') + '>' + escHtml(o.label) + '</option>';
    });
    html += '</select>';
    html += '<button type="button" class="gpc-home-jump-clear" data-hf-clear="' + id + '"' + (on ? '' : ' hidden') + ' aria-label="Clear ' + escAttr(current || placeholder) + ' filter">';
    html += '<span data-home-clear-label>' + escHtml(current) + '</span>';
    html += '<span class="gpc-home-jump-x" aria-hidden="true">×</span></button></div>';
    return html;
  }

  function renderHeaderFilters() {
    var root = document.getElementById('gpc-browse-jump');
    if (!root) return;
    if (!hasHeaderFilters()) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }
    bindHeaderFilters();
    var html = '';
    headerFilterIds().forEach(function (id) {
      var placeholder = headerFilterPlaceholder(id);
      var opts = id === 'cat' ? headerCatOpts() : (id === 'type' ? headerTypeOpts() : (id === 'model' ? headerModelOpts() : (id === 'gun' ? headerGunOpts() : (id === 'gen' ? headerGenOpts() : headerBrandOpts()))));
      var value = null;
      if (id === 'cat') value = (state.cat && !platform.lockedCat) ? state.cat : null;
      else if (id === 'type') value = state.type;
      else if (id === 'gun') value = state.gun || null;
      else if (id === 'gen') value = state.gen || null;
      else if (id === 'model') {
        if (kind === 'knives') value = (state.series && state.series !== 'all') ? state.series : null;
        else value = (state.model && state.model !== 'all') ? state.model : null;
      } else value = (state.brand && state.brand !== 'all') ? state.brand : null;
      if (opts.length < 2 && !value) return;
      html += filterWidget(id, placeholder, value, opts);
    });
    if (state.type || (kind === 'gear' && platform.quickTypes) || (kind === 'knives' && state.brand)) {
      buildFacetGroups(filtered()).forEach(function (g) {
        if (!g || g.id === 'maker' || g.id === 'group' || !g.options || !g.options.length) return;
        var placeholder = g.id === 'cal' ? 'Caliber' : g.id === 'cap' ? 'Capacity' : g.id === 'style' ? 'Style' : g.id === 'carry' ? 'Carry' : (g.allLabel || 'Filter');
        html += filterWidget(g.id, placeholder, facetValue(g.id), g.options);
      });
    }
    var anyOn = !!(state.type || (state.model && state.model !== 'all') || (state.brand && state.brand !== 'all') ||
      state.gun || state.gen ||
      (state.series && state.series !== 'all') || (kind === 'gear' && state.cat && !platform.lockedCat) ||
      state.fCal || state.fCap || state.fStyle || state.fCarry || state.fGroup || state.fMaker || state.fColor || state.fJob ||
      state.fBlade || state.sort);
    if (anyOn) {
      html += '<button type="button" class="gpc-hf-clear-all" data-hf-clear-all>Clear all</button>';
    }
    root.innerHTML = html;
    root.hidden = !html;
    syncHeaderOffset();
  }

  function setStatus(t) { if (statusEl) statusEl.textContent = t || ''; }

  function crumbHref(step) {
    var u = new URL(window.location.origin + window.location.pathname);
    if (step === 'root') return u.pathname;
    if (kind === 'knives') {
      if (state.brand) u.searchParams.set('brand', state.brand);
      if (step === 'results' && state.series) u.searchParams.set('series', state.series);
    } else if (kind === 'gear') {
      if (state.cat && !platform.lockedCat) u.searchParams.set('cat', state.cat);
      if (step === 'cat') return u.pathname + u.search;
      if (state.type) u.searchParams.set('type', state.type);
      if (step === 'gtype') return u.pathname + u.search;
      if (state.brand) u.searchParams.set('brand', state.brand);
      if (step === 'brand') return u.pathname + u.search;
      if (state.series) u.searchParams.set('series', state.series);
    } else {
      if (handle !== 'parts' && state.model && state.model !== 'all') u.searchParams.set('model', state.model);
      if (step === 'type') return u.pathname + u.search;
      if (state.type) u.searchParams.set('type', state.type);
      if (step === 'gtype') return u.pathname + u.search;
      if (state.gun) u.searchParams.set('gun', state.gun);
      if (step === 'gun') return u.pathname + u.search;
      if (handle === 'parts' && state.model && state.model !== 'all') u.searchParams.set('model', state.model);
      if (step === 'model') return u.pathname + u.search;
      if (state.brand) u.searchParams.set('brand', state.brand);
    }
    return u.pathname + u.search;
  }

  function applyCrumb(step) {
    if (step === 'root') {
      state.model = hasModelStep() ? null : (kind === 'firearm' ? 'all' : null);
      state.type = null;
      state.brand = null;
      state.series = null;
      state.gun = null;
      state.gen = null;
      state.cat = platform.lockedCat || null;
    }
    if (step === 'type') { state.type = null; state.brand = null; state.series = null; state.gun = null; }
    if (step === 'brand') { state.series = null; }
    if (step === 'cat') { state.type = null; state.brand = null; state.series = null; }
    if (step === 'gtype') { state.brand = null; state.series = null; }
    if (step === 'gun') { state.brand = null; if (handle === 'parts') state.model = 'all'; }
    if (step === 'model') { state.brand = null; }
    commit(false);
  }

  function bindCrumbs() {
    if (!crumbsEl || crumbsEl.getAttribute('data-gpc-bound')) return;
    crumbsEl.setAttribute('data-gpc-bound', '1');
    crumbsEl.addEventListener('click', function (e) {
      var a = e.target.closest('[data-crumb]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      applyCrumb(a.getAttribute('data-crumb'));
    });
  }

  function syncHeaderOffset() {
    if (typeof window.gpcSyncHeaderOffset === 'function') {
      window.gpcSyncHeaderOffset();
      return;
    }
    var header = document.getElementById('shopify-section-header');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    if (h) document.documentElement.style.setProperty('--gpc-header-h', h + 'px');
  }

  function renderCrumbs() {
    if (!crumbsEl) return;
    bindCrumbs();
    syncHeaderOffset();
    var parts = [
      { label: 'Home', href: '/' },
      { label: platform.heading || platform.name, step: 'root' }
    ];
    if (kind === 'knives') {
      if (state.brand) {
        parts.push({ label: knifeBrandLabel(state.brand), step: 'brand' });
      }
      if (state.series) {
        parts.push({ label: knifeSeriesLabel(state.brand, state.series), step: 'results' });
      }
    } else if (kind === 'gear') {
      if (state.cat && !platform.lockedCat) {
        parts.push({ label: gearCatLabel(state.cat), step: 'cat' });
      }
      if (state.type) {
        parts.push({ label: gearTypeLabel(state.cat, state.type), step: 'gtype' });
      }
      if (state.brand) {
        parts.push({
          label: state.brand === 'all' ? 'All brands' : opticBrandLabel(state.brand),
          step: state.series ? 'brand' : 'results'
        });
      }
      if (state.series) {
        parts.push({
          label: state.series === 'all' ? 'All series' : opticSeriesLabel(state.brand, state.series),
          step: 'results'
        });
      }
    } else {
      if (state.model && platform.models && platform.models.length) {
        parts.push({
          label: state.model === 'all' ? 'All ' + platform.name : firearmModelLabel(state.model),
          step: 'type'
        });
      }
      if (state.type) {
        parts.push({
          label: typeLabelOf(state.type),
          step: (state.gun || state.brand) ? 'gtype' : 'results'
        });
      }
      if (state.gun) {
        parts.push({
          label: gunFamilyLabel(state.gun),
          step: (state.model && state.model !== 'all') || state.brand ? 'gun' : 'results'
        });
      }
      if (handle === 'parts' && state.model && state.model !== 'all') {
        parts.push({
          label: firearmModelLabel(state.model),
          step: state.brand ? 'model' : 'results'
        });
      }
      if (state.brand) {
        parts.push({
          label: state.brand === 'all' ? 'All brands' : opticBrandLabel(state.brand),
          step: 'results'
        });
      }
    }
    crumbsEl.innerHTML = parts.map(function (p, i) {
      var last = i === parts.length - 1;
      var node;
      var label = escHtml(p.label);
      if (p.href) {
        node = '<a href="' + p.href + '" class="gpc-crumb-link">' + label + '</a>';
      } else if (last) {
        node = '<span class="gpc-crumb-current">' + label + '</span>';
      } else {
        node = '<a href="' + escAttr(crumbHref(p.step)) + '" class="gpc-crumb-link" data-crumb="' + p.step + '">' + label + '</a>';
      }
      if (!last) node += '<span class="gpc-crumb-sep" aria-hidden="true">/</span>';
      return node;
    }).join('');
  }

  function browseTitle() {
    var base = platform.heading || (platform.name + ' parts');
    if (kind === 'knives') {
      if (state.series) return knifeSeriesLabel(state.brand, state.series) + ' — ' + base;
      if (state.brand) return knifeBrandLabel(state.brand) + ' — ' + base;
      return base;
    }
    if (kind === 'gear') {
      if (state.type) return gearTypeLabel(state.cat, state.type) + ' — ' + (platform.heading || platform.name);
      if (state.cat && !platform.lockedCat) return gearCatLabel(state.cat) + ' — Gear';
      return base;
    }
    if (handle === 'parts') {
      var partName = state.type ? typeLabelOf(state.type) : '';
      var gunName = state.gun ? gunFamilyLabel(state.gun) : '';
      var modelName = (state.model && state.model !== 'all') ? firearmModelLabel(state.model) : '';
      if (partName && modelName) return modelName + ' ' + partName;
      if (partName && gunName) return gunName + ' ' + partName;
      if (partName) return partName;
      if (gunName) return gunName + ' parts';
      return base;
    }
    if (state.type) return platform.name + ' ' + typeLabelOf(state.type);
    if (hasModelStep() && state.model && state.model !== 'all') {
      return firearmModelLabel(state.model) + ' — ' + platform.name + ' parts';
    }
    return base;
  }

  function browseIntroHidden() {
    if (kind === 'knives') return !!(state.brand || (state.series && state.series !== 'all'));
    if (kind === 'gear') {
      if (state.type || (state.brand && state.brand !== 'all') || state.series) return true;
      if (state.cat && !platform.lockedCat) return true;
      return false;
    }
    if (state.type) return true;
    if (state.gun) return true;
    if (state.brand && state.brand !== 'all') return true;
    if (hasModelStep() && state.model && state.model !== 'all') return true;
    return false;
  }

  function syncBrowseChrome() {
    var drilled = browseIntroHidden();
    var introEl = document.getElementById('gpc-firearm-intro');
    var introWrap = document.getElementById('gpc-firearm-intro-wrap');
    var pageTitle = browseTitle();
    if (wrapEl) {
      wrapEl.classList.toggle('gpc-browse-drilled', drilled);
      wrapEl.classList.add('gpc-browse-ready');
    }
    if (nameEl) nameEl.textContent = pageTitle;
    try {
      if (pageTitle) document.title = pageTitle + ' | Gun Parts Central';
    } catch (err) {}
    if (introWrap) introWrap.hidden = drilled;
    else if (introEl) introEl.hidden = drilled;
    if (backEl) backEl.classList.add('hidden');
    if (!items.length && statusEl && !drilled) {
      statusEl.textContent = 'Loading parts…';
    }
  }

  function renderBack() {
    if (backEl) backEl.classList.add('hidden');
  }

  function cardHtml(title, sub, key) {
    return '<button type="button" data-key="' + key + '" class="gpc-browse-card gpc-type-hit text-left product-card bg-zinc-900 border border-zinc-800 hover:border-yellow-400 rounded-2xl p-4 transition-colors">' +
      '<div class="font-semibold">' + title + '</div>' +
      '<div class="text-[11px] text-zinc-500 mt-1">' + sub + '</div></button>';
  }

  var typePreviewPools = {};
  var typePreviewIndex = {};
  var typePreviewTimers = [];
  var PREVIEW_ROTATE_MAX = 12;

  function previewCacheKey(id) {
    return [kind, state.cat || '', state.model || '', state.type || '', state.brand || '', state.series || '', id].join(':');
  }

  function shuffleHits(list) {
    var i, j, t;
    for (i = list.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      t = list[i];
      list[i] = list[j];
      list[j] = t;
    }
    return list;
  }

  function hitPriceText(hit) {
    var raw = hit && hit.price;
    if (raw === undefined || raw === null || raw === '') return '';
    var p = typeof raw === 'string' ? parseFloat(raw) : raw;
    if (isNaN(p)) return '';
    return '$' + p.toFixed(2);
  }

  function pickTypePreview(typeId, pool) {
    var key = previewCacheKey(typeId);
    if (Object.prototype.hasOwnProperty.call(typePreviewPools, key)) {
      var cached = typePreviewPools[key] || [];
      if (!cached.length) return null;
      return cached[typePreviewIndex[key] || 0] || cached[0];
    }
    var ranked = pool.filter(function (h) {
      return h.image && h.inventory_available !== false;
    });
    if (!ranked.length) ranked = pool.filter(function (h) { return h.image; });
    ranked = shuffleHits(ranked.slice());
    if (ranked.length > PREVIEW_ROTATE_MAX) ranked = ranked.slice(0, PREVIEW_ROTATE_MAX);
    typePreviewPools[key] = ranked;
    typePreviewIndex[key] = 0;
    return ranked[0] || null;
  }

  function stopTypePreviewRotate() {
    typePreviewTimers.forEach(function (id) { clearInterval(id); });
    typePreviewTimers = [];
  }

  function applyPreviewHit(card, hit) {
    if (!card || !hit) return;
    var media = card.querySelector('.gpc-related-img');
    var img = media && media.querySelector('img');
    if (!img && media) {
      img = document.createElement('img');
      img.alt = '';
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    if (!img) return;
    var src = hit.image || '';
    if (window.GPC && typeof window.GPC.img === 'function') src = window.GPC.img(src, 400);
    if (img.getAttribute('src') === src) return;
    if (!src) {
      img.removeAttribute('src');
      return;
    }
    var pre = new Image();
    pre.onload = function () { img.src = src; };
    pre.onerror = function () { img.src = src; };
    pre.src = src;
  }

  function advanceTypePreview(card) {
    if (!card || !card.isConnected || card.getAttribute('data-paused') === '1') return;
    if (document.hidden) return;
    var typeId = card.getAttribute('data-preview-key');
    var key = previewCacheKey(typeId);
    var pool = typePreviewPools[key];
    if (!pool || pool.length < 2) return;
    var i = ((typePreviewIndex[key] || 0) + 1) % pool.length;
    typePreviewIndex[key] = i;
    applyPreviewHit(card, pool[i]);
    var next = pool[(i + 1) % pool.length];
    if (next && next.image) {
      var pre = new Image();
      pre.src = (window.GPC && window.GPC.img) ? window.GPC.img(next.image, 400) : next.image;
    }
  }

  function startTypePreviewRotate() {
    stopTypePreviewRotate();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!cardsEl) return;
    cardsEl.querySelectorAll('.gpc-type-preview[data-preview-key]').forEach(function (card, i) {
      var key = previewCacheKey(card.getAttribute('data-preview-key'));
      var pool = typePreviewPools[key];
      if (!pool || pool.length < 2) return;
      card.addEventListener('mouseenter', function () { card.setAttribute('data-paused', '1'); });
      card.addEventListener('mouseleave', function () { card.removeAttribute('data-paused'); });
      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) card.setAttribute('data-on-screen', '1');
          else card.removeAttribute('data-on-screen');
        }, { rootMargin: '80px', threshold: 0.02 });
        io.observe(card);
      } else {
        card.setAttribute('data-on-screen', '1');
      }
      var ms = 5500 + (i % 6) * 450;
      typePreviewTimers.push(setInterval(function () {
        if (card.getAttribute('data-on-screen') !== '1') return;
        advanceTypePreview(card);
      }, ms));
    });
  }

  function bindPreviewCaptions() {
    if (!cardsEl) return;
    function measure() {
      cardsEl.querySelectorAll('.gpc-home-mosaic-more').forEach(function (box) {
        var cap = box.querySelector('[data-home-caption]');
        var btn = box.querySelector('[data-home-expand]');
        if (!cap || !btn) return;
        if (cap.classList.contains('is-open')) return;
        cap.classList.add('is-clamp');
        var overflow = cap.scrollHeight > cap.clientHeight + 1;
        btn.hidden = !overflow;
        box.classList.toggle('has-overflow', overflow);
      });
    }
    if (cardsEl.getAttribute('data-cap-bound') !== '1') {
      cardsEl.setAttribute('data-cap-bound', '1');
      cardsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-home-expand]');
        if (!btn || !cardsEl.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        var box = btn.closest('.gpc-home-mosaic-more');
        var cap = box && box.querySelector('[data-home-caption]');
        if (!cap) return;
        var open = !cap.classList.contains('is-open');
        cap.classList.toggle('is-open', open);
        cap.classList.toggle('is-clamp', !open);
        box.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.setAttribute('aria-label', open ? 'Show less' : 'Show more');
        btn.textContent = open ? 'Less' : '…';
        if (!open) measure();
      });
    }
    measure();
    requestAnimationFrame(measure);
    setTimeout(measure, 200);
  }

  function typePreviewHtml(row, hit, moreHref, bucket) {
    var img = hit.image || '';
    var href = escAttr(moreHref);
    var key = escAttr(row.key);
    var lead = escHtml(clickHereLead(row.title));
    var caption = escHtml(previewCaption(row, bucket || []));
    return '<article class="product-card gpc-related-card gpc-type-preview overflow-hidden" data-preview-key="' + key + '">' +
      '<a href="' + href + '" class="gpc-related-product" data-key="' + key + '">' +
        '<div class="gpc-home-mosaic-head"><span class="gpc-mosaic-pill">' + escHtml(row.title) + '</span></div>' +
        '<div class="gpc-related-img">' +
          (img ? '<img src="' + escAttr((window.GPC && window.GPC.img) ? window.GPC.img(img, 400) : img) + '" alt="' + escAttr((hit && hit.title) || row.title || '') + '" width="400" height="400" loading="lazy" decoding="async">' : '') +
        '</div>' +
      '</a>' +
      '<div class="gpc-home-mosaic-more">' +
        '<a href="' + href + '" class="gpc-home-mosaic-caplink" data-key="' + key + '">' +
          '<span class="gpc-home-mosaic-lead">' + lead + ':</span>' +
          '<p class="gpc-home-mosaic-caption is-clamp" data-home-caption>' + caption + '</p>' +
        '</a>' +
        '<button type="button" class="gpc-home-mosaic-expand" data-home-expand hidden aria-expanded="false" aria-label="Show more">…</button>' +
      '</div>' +
    '</article>';
  }

  function productBrowseQuery() {
    var q = [];
    function add(k, v) {
      if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
    add('gpc_plat', handle);
    add('gpc_platn', platform.name);
    add('gpc_kind', kind || 'firearm');
    if (kind === 'knives') {
      if (state.brand) {
        add('gpc_brand', state.brand);
        add('gpc_brandn', knifeBrandLabel(state.brand));
      }
      if (state.series) add('gpc_series', state.series);
    } else if (kind === 'gear') {
      if (state.cat) add('gpc_cat', state.cat);
      if (state.type) {
        add('gpc_type', state.type);
        add('gpc_typen', gearTypeLabel(state.cat, state.type));
      }
      if (state.brand) {
        add('gpc_brand', state.brand);
        add('gpc_brandn', state.brand === 'all' ? 'All brands' : opticBrandLabel(state.brand));
      }
    } else {
      if (state.model) {
        add('gpc_model', state.model);
        add('gpc_modeln', state.model === 'all' ? ('All ' + platform.name) : firearmModelLabel(state.model));
      }
      if (state.type) {
        add('gpc_type', state.type);
        add('gpc_typen', typeLabelOf(state.type));
      }
      if (state.brand) {
        add('gpc_brand', state.brand);
        add('gpc_brandn', state.brand === 'all' ? 'All brands' : opticBrandLabel(state.brand));
      }
    }
    return q.length ? ('?' + q.join('&')) : '';
  }

  var opticsTargetCache = null;

  function isPaperTargetHit(h) {
    var u = String(h.title || '').toUpperCase();
    if (/STEEL|HANGER|STAND|STAKE/.test(u) && !/PAPER|SHT-N-C|SPLASH|BULLSEYE/.test(u)) return false;
    return /TARGET|\bTGT\b|\bTRGT\b|BULLSEYE|SHT-N-C|EZE-SCORER|SIGHT-IN|SIGHTIN/.test(u);
  }

  function renderOpticsTargetsTieIn() {
    if (!resultsEl || platform.lockedCat !== 'optics') {
      var old = document.getElementById('gpc-optics-targets');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      return;
    }
    function paint(hits) {
      var el = document.getElementById('gpc-optics-targets');
      if (!hits || !hits.length) {
        if (el && el.parentNode) el.parentNode.removeChild(el);
        return;
      }
      var q = '?gpc_plat=range&gpc_platn=Range&gpc_kind=gear&gpc_cat=range&gpc_type=targets&gpc_typen=Targets';
      var html = '<div id="gpc-optics-targets" class="col-span-full mt-10 pt-8 border-t border-zinc-800">' +
        '<div class="text-lg font-semibold text-zinc-100">Don\'t forget paper targets</div>' +
        '<p class="text-sm text-zinc-400 mt-1 max-w-2xl">Sight in that optic. Paper and splash targets from the range aisle.</p>' +
        '<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 mt-4">' +
        hits.map(function (h) { return hitCard(h, q); }).join('') +
        '</div>' +
        '<a href="/pages/gear?cat=range&type=targets" class="inline-block mt-4 text-sm font-semibold text-yellow-400 hover:underline">See all targets</a>' +
        '</div>';
      if (el) el.outerHTML = html;
      else if (hitsEl && hitsEl.parentNode) hitsEl.insertAdjacentHTML('afterend', html);
    }
    if (opticsTargetCache) {
      paint(opticsTargetCache);
      return;
    }
    Promise.all([
      browseQuery('paper target'),
      browseQuery('Shoot-N-C'),
      browseQuery('Birchwood target')
    ]).then(function (sets) {
      var seen = {};
      var acc = [];
      sets.forEach(function (arr) {
        (arr || []).forEach(function (h) {
          if (seen[h.objectID] || !isPaperTargetHit(h)) return;
          if (h.inventory_available === false && acc.length >= 5) return;
          seen[h.objectID] = 1;
          acc.push(h);
        });
      });
      acc.sort(function (a, b) {
        var ao = a.inventory_available === false ? 1 : 0;
        var bo = b.inventory_available === false ? 1 : 0;
        return ao - bo;
      });
      opticsTargetCache = acc.slice(0, 5);
      paint(opticsTargetCache);
    }).catch(function () { paint([]); });
  }

  function hitCard(hit, productQ) {
    if (window.GPC && typeof window.GPC.tileHtml === 'function') {
      return window.GPC.tileHtml(hit, '/products/' + (hit.handle || '') + (productQ || ''));
    }
    return '';
  }

  function hitPrice(hit) {
    var raw = hit && (hit.price != null ? hit.price : hit.price_min);
    var n = typeof raw === 'string' ? parseFloat(raw) : raw;
    return isNaN(n) ? 0 : n;
  }

  var BLADE_BUCKETS = [
    { id: 'u3', label: 'Under 3"', lo: 0, hi: 3 },
    { id: '3-4', label: '3–4"', lo: 3, hi: 4 },
    { id: '4-6', label: '4–6"', lo: 4, hi: 6 },
    { id: '6p', label: '6" and up', lo: 6, hi: 99 }
  ];

  function bladeBucketOf(n) {
    if (n == null || !isFinite(n)) return '';
    var i;
    for (i = 0; i < BLADE_BUCKETS.length; i++) {
      var b = BLADE_BUCKETS[i];
      if (n >= b.lo && n < b.hi) return b.id;
    }
    return '';
  }

  function bladeFacetOptions(list) {
    var counts = {};
    list.forEach(function (h) {
      var id = bladeBucketOf(h.bladeIn);
      if (!id) return;
      counts[id] = (counts[id] || 0) + 1;
    });
    return BLADE_BUCKETS.filter(function (b) { return counts[b.id]; }).map(function (b) {
      return { id: b.id, label: b.label, n: counts[b.id] };
    });
  }

  var FACET_MIN = 2;
  var FACET_CHIP_MAX = 6;
  var OPTIC_KIND_LABELS = {
    'red-dots': 'Red dots',
    scopes: 'Scopes',
    spotting: 'Spotting',
    binoculars: 'Binoculars',
    magnifiers: 'Magnifiers',
    rangefinders: 'Rangefinders',
    thermal: 'Thermal & IR',
    combos: 'Combos',
    lasers: 'Lasers',
    'bore-sighters': 'Bore sighters',
    mounts: 'Mounts',
    accessories: 'Covers',
    other: 'Other'
  };
  var COLOR_LABELS = { tan: 'Tan', fde: 'FDE', blk: 'Black', od: 'OD Green', gry: 'Gray' };
  var STYLE_LABELS = { clear: 'Clear', tan: 'Tan', black: 'Black', drum: 'Drum' };
  var CARRY_LABELS = { iwb: 'IWB', owb: 'OWB', aiwb: 'AIWB' };

  function escAttr(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function escHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function makerKeyOf(hit) {
    if (hit.gbrand) return hit.gbrand;
    if (hit.fbrand) return hit.fbrand;
    if (hit.kbrand && hit.kbrand !== 'other') return hit.kbrand;
    return vendorBrandKey(hit.vendor);
  }
  function makerLabelOf(hit) {
    var id = makerKeyOf(hit);
    if (hit.kbrand) return knifeBrandLabel(id);
    return opticBrandLabel(id, hit.vendor);
  }

  function countBy(list, fn) {
    var c = {};
    list.forEach(function (h) {
      var k = fn(h);
      if (!k) return;
      c[k] = (c[k] || 0) + 1;
    });
    return c;
  }

  function facetOptions(counts, labels, min) {
    min = min == null ? FACET_MIN : min;
    var keys = Object.keys(counts).filter(function (k) { return counts[k] >= min; });
    keys.sort(function (a, b) {
      if (labels && labels[a] && labels[b]) {
        return String(labels[a]).localeCompare(String(labels[b]), undefined, { sensitivity: 'base' });
      }
      return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
    });
    return keys.map(function (k) {
      return { id: k, label: (labels && labels[k]) || k, n: counts[k] };
    });
  }

  function poolShare(list, fn) {
    if (!list.length) return false;
    var n = 0;
    list.forEach(function (h) { if (fn(h)) n += 1; });
    return n >= Math.ceil(list.length * 0.5);
  }

  function isOpticsPool(list) {
    return state.cat === 'optics' || poolShare(list, function (h) { return h.gcat === 'optics'; });
  }
  function isMagPool(list) {
    return state.type === 'magazines' || poolShare(list, function (h) { return h.ptype === 'magazines'; });
  }
  function isHolsterPool(list) {
    return state.type === 'holsters' || poolShare(list, function (h) { return h.ptype === 'holsters'; });
  }
  function isMiscPool(list) {
    return state.type === 'other' || poolShare(list, function (h) { return h.ptype === 'other'; });
  }

  function buildFacetGroups(list) {
    var groups = [];
    if (isOpticsPool(list)) {
      var kindLabels = {
        'red-dots': OPTIC_KIND_LABELS['red-dots'],
        scopes: OPTIC_KIND_LABELS.scopes,
        spotting: OPTIC_KIND_LABELS.spotting,
        binoculars: OPTIC_KIND_LABELS.binoculars,
        magnifiers: OPTIC_KIND_LABELS.magnifiers,
        combos: state.brand === 'eotech' ? 'HHS kits' : 'Combos',
        lasers: OPTIC_KIND_LABELS.lasers,
        mounts: OPTIC_KIND_LABELS.mounts,
        accessories: OPTIC_KIND_LABELS.accessories,
        other: OPTIC_KIND_LABELS.other
      };
      groups.push({
        id: 'group',
        ui: 'chips',
        options: facetOptions(countBy(list, function (h) { return opticKindOf(h.title); }), kindLabels)
      });
      groups.push({
        id: 'color',
        ui: 'chips',
        options: facetOptions(countBy(list, function (h) { return colorOf(h.title); }), COLOR_LABELS)
      });
    } else if (isMagPool(list)) {
      var calOpts = facetOptions(countBy(list, function (h) { return magCalOf(h.title); }), CAL_LABELS, 1);
      calOpts.sort(function (a, b) {
        var ia = 999;
        var ib = 999;
        MAG_CALS.forEach(function (c, i) {
          if (c.id === a.id) ia = i;
          if (c.id === b.id) ib = i;
        });
        return ia - ib;
      });
      if (calOpts.length >= 2 || (calOpts.length === 1 && calOpts[0].n < list.length)) {
        groups.push({
          id: 'cal',
          ui: calOpts.length > FACET_CHIP_MAX ? 'select' : 'chips',
          allLabel: 'All calibers',
          options: calOpts
        });
      }
      var capOpts = facetOptions(countBy(list, function (h) { return magCapOf(h.title); }), null);
      capOpts.forEach(function (o) { o.label = o.id + ' rd'; });
      capOpts.sort(function (a, b) { return parseInt(a.id, 10) - parseInt(b.id, 10); });
      groups.push({ id: 'cap', ui: 'chips', options: capOpts });
      groups.push({
        id: 'style',
        ui: 'chips',
        options: facetOptions(countBy(list, function (h) { return magStyleOf(h.title); }), STYLE_LABELS)
      });
    } else if (isHolsterPool(list)) {
      groups.push({
        id: 'carry',
        ui: 'chips',
        options: facetOptions(countBy(list, function (h) { return holsterCarryOf(h.title); }), CARRY_LABELS)
      });
    } else if (isMiscPool(list)) {
      var jobOpts = facetOptions(countBy(list, function (h) { return miscJobOf(h.title); }), MISC_JOBS, 1);
      if (jobOpts.length >= 2) {
        groups.push({
          id: 'job',
          ui: jobOpts.length > FACET_CHIP_MAX ? 'select' : 'chips',
          allLabel: 'All types',
          options: jobOpts
        });
      }
    }

    if (!state.brand || state.brand === 'all') {
      var makers = {};
      var makerLabels = {};
      list.forEach(function (h) {
        var id = makerKeyOf(h);
        if (!id || id === 'other') return;
        makers[id] = (makers[id] || 0) + 1;
        if (!makerLabels[id]) makerLabels[id] = makerLabelOf(h);
      });
      var makerOpts = facetOptions(makers, makerLabels, 1);
      makerOpts.sort(function (a, b) {
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });
      if (makerOpts.length >= 2) {
        groups.push({
          id: 'maker',
          ui: makerOpts.length > FACET_CHIP_MAX ? 'select' : 'chips',
          allLabel: 'All manufacturers',
          options: makerOpts
        });
      }
    }

    return groups.filter(function (g) {
      if (!g.options || !g.options.length) return false;
      if (g.id === 'style' || g.id === 'carry') return true;
      return g.options.length >= 2;
    });
  }

  function facetValue(id) {
    if (id === 'group') return state.fGroup;
    if (id === 'maker') return state.fMaker;
    if (id === 'color') return state.fColor;
    if (id === 'cap') return state.fCap;
    if (id === 'cal') return state.fCal;
    if (id === 'style') return state.fStyle;
    if (id === 'carry') return state.fCarry;
    if (id === 'job') return state.fJob;
    if (id === 'blade') return state.fBlade;
    return null;
  }

  function setFacetValue(id, value) {
    if (id === 'group') state.fGroup = value;
    else if (id === 'maker') state.fMaker = value;
    else if (id === 'color') state.fColor = value;
    else if (id === 'cap') state.fCap = value;
    else if (id === 'cal') state.fCal = value;
    else if (id === 'style') state.fStyle = value;
    else if (id === 'carry') state.fCarry = value;
    else if (id === 'job') state.fJob = value;
    else if (id === 'blade') state.fBlade = value;
  }

  function hitMatchesFacets(h) {
    if (state.inStock && h.inventory_available === false) return false;
    if (state.fGroup && opticKindOf(h.title) !== state.fGroup) return false;
    if (state.fColor && colorOf(h.title) !== state.fColor) return false;
    if (state.fCap && magCapOf(h.title) !== state.fCap) return false;
    if (state.fCal && magCalOf(h.title) !== state.fCal) return false;
    if (state.fStyle && magStyleOf(h.title) !== state.fStyle) return false;
    if (state.fCarry && holsterCarryOf(h.title) !== state.fCarry) return false;
    if (state.fJob && miscJobOf(h.title) !== state.fJob) return false;
    if (state.fMaker && makerKeyOf(h) !== state.fMaker) return false;
    if (state.fBlade) {
      var bucket = bladeBucketOf(h.bladeIn);
      if (bucket !== state.fBlade) return false;
    }
    return true;
  }

  function onProductFacetClick(e) {
    var chip = e.target.closest('[data-facet]');
    if (!chip || chip.tagName === 'SELECT') return;
    var id = chip.getAttribute('data-facet');
    if (id === 'stock') {
      state.inStock = !state.inStock;
      commit(false, true);
      return;
    }
    if (id === 'sort') {
      var sortVal = chip.getAttribute('data-value') || '';
      state.sort = state.sort === sortVal ? '' : sortVal;
      commit(false, true);
      return;
    }
    var value = chip.getAttribute('data-value');
    if (!id || !value) return;
    setFacetValue(id, facetValue(id) === value ? null : value);
    commit(false, true);
  }

  function onProductFacetChange(e) {
    var sel = e.target.closest('select[data-facet]');
    if (!sel) return;
    setFacetValue(sel.getAttribute('data-facet'), sel.value || null);
    commit(false, true);
  }

  function bindProductFacets() {
    if (!statsEl || statsEl.getAttribute('data-gpc-facets')) return;
    statsEl.setAttribute('data-gpc-facets', '1');
    statsEl.addEventListener('click', onProductFacetClick);
    statsEl.addEventListener('change', onProductFacetChange);
  }

  function renderProductToolbar(pool, shown) {
    if (!statsEl) return;
    bindProductFacets();
    var groups = hasHeaderFilters() ? [] : buildFacetGroups(pool);
    var html = '<div class="gpc-product-toolbar"><div class="gpc-facet-row">';
    groups.forEach(function (g) {
      var cur = facetValue(g.id);
      if (g.ui === 'select') {
        html += '<label class="gpc-facet-select-wrap"><span class="gpc-sr">' + escHtml(g.allLabel || 'Filter') + '</span>';
        html += '<select class="gpc-facet-select" data-facet="' + g.id + '">';
        html += '<option value="">' + escHtml(g.allLabel || 'All') + '</option>';
        g.options.forEach(function (o) {
          html += '<option value="' + escAttr(o.id) + '"' + (cur === o.id ? ' selected' : '') + '>' + escHtml(o.label) + '</option>';
        });
        html += '</select></label>';
      } else {
        html += '<div class="gpc-facet-chips" role="group">';
        g.options.forEach(function (o) {
          var on = cur === o.id;
          html += '<button type="button" class="gpc-facet-chip' + (on ? ' is-on' : '') + '" data-facet="' + g.id + '" data-value="' + escAttr(o.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + escHtml(o.label) + '</button>';
        });
        html += '</div>';
      }
    });
    html += '<button type="button" class="gpc-stock-toggle' + (state.inStock ? ' is-on' : '') + '" data-facet="stock" aria-pressed="' + (state.inStock ? 'true' : 'false') + '">In stock only</button>';
    if (kind === 'knives') {
      var bladeOpts = bladeFacetOptions(pool);
      if (bladeOpts.length >= 2) {
        html += '<div class="gpc-facet-chips" role="group" aria-label="Blade length">';
        bladeOpts.forEach(function (o) {
          var on = state.fBlade === o.id;
          html += '<button type="button" class="gpc-facet-chip' + (on ? ' is-on' : '') + '" data-facet="blade" data-value="' + escAttr(o.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + escHtml(o.label) + '</button>';
        });
        html += '</div>';
      }
    }
    html += '<button type="button" class="gpc-search-btn' + (state.sort === 'lo' ? ' is-on' : '') + '" data-facet="sort" data-value="lo" aria-pressed="' + (state.sort === 'lo' ? 'true' : 'false') + '">Low to high</button>';
    html += '<button type="button" class="gpc-search-btn' + (state.sort === 'hi' ? ' is-on' : '') + '" data-facet="sort" data-value="hi" aria-pressed="' + (state.sort === 'hi' ? 'true' : 'false') + '">High to low</button>';
    html += '</div>';
    var n = shown.length;
    var total = pool.length;
    html += '<div class="gpc-facet-count">';
    if (n === total) {
      html += '<span class="gpc-facet-n">' + n.toLocaleString('en-US') + '</span> products';
    } else {
      html += '<span class="gpc-facet-n">' + n.toLocaleString('en-US') + '</span> of ' + total.toLocaleString('en-US');
    }
    html += '</div></div>';
    statsEl.innerHTML = html;
  }

  function typeChipRows() {
    var tc = {};
    var optic = kind === 'gear' && platform.lockedCat === 'optics';
    items.forEach(function (h) {
      if (optic) {
        if (state.brand && state.brand !== 'all' && (h.gbrand || vendorBrandKey(h.vendor)) !== state.brand) return;
        tc[h.gtype] = (tc[h.gtype] || 0) + 1;
        return;
      }
      if (state.model && state.model !== 'all' && !hitHasModel(h, state.model)) return;
      tc[h.ptype] = (tc[h.ptype] || 0) + 1;
    });
    var preferred = platform.quickTypes || [];
    var out = [];
    var seen = {};
    function take(id, min) {
      var n = tc[id] || 0;
      if (!n || seen[id]) return;
      if (typeHidden(id)) return;
      if (n < (min || 1)) return;
      seen[id] = 1;
      out.push({ id: id, n: n });
    }
    preferred.forEach(function (id) { take(id, 1); });
    if (optic) {
      (GEAR_CATS.filter(function (c) { return c.id === 'optics'; })[0].l2 || []).forEach(function (t) {
        take(t.id, 1);
      });
      return out;
    }
    TYPES.forEach(function (t) {
      var n = tc[t.id] || 0;
      if (!n) return;
      if (CORE_TYPES[t.id] || n >= TYPE_MIN) take(t.id, CORE_TYPES[t.id] ? 1 : TYPE_MIN);
    });
    return out;
  }

  function typeLayerRows(list) {
    var tc = {};
    var ic = {};
    TYPES.forEach(function (t) {
      tc[t.id] = 0;
      ic[t.id] = 0;
    });
    (list || []).forEach(function (h) {
      if (!h.ptype) return;
      tc[h.ptype] = (tc[h.ptype] || 0) + 1;
      if (h.inventory_available !== false) ic[h.ptype] = (ic[h.ptype] || 0) + 1;
    });
    var rows = TYPES.filter(function (t) {
      var n = tc[t.id] || 0;
      if (!n) return false;
      if (typeHidden(t.id)) return false;
      if (CORE_TYPES[t.id]) return true;
      return n >= TYPE_MIN;
    }).map(function (t) {
      var n = tc[t.id];
      var inn = ic[t.id] || 0;
      var sub;
      if (inn === 0) sub = n + ' out of stock';
      else if (state.inStock) sub = inn + (inn < STOP_AT ? ' — show products' : ' parts');
      else sub = n + (n < STOP_AT ? ' — show products' : ' parts');
      return { key: t.id, title: typeLabelOf(t.id), sub: sub };
    });
    var prefer = (platform.preferTypesByModel && state.model && platform.preferTypesByModel[state.model]) || platform.preferTypes || [];
    if (prefer.length) {
      rows.sort(function (a, b) {
        var ai = prefer.indexOf(a.key);
        var bi = prefer.indexOf(b.key);
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });
    }
    return rows;
  }

  function showBrandLayer(list) {
    if (!list || state.brand || list.length < STOP_AT) return false;
    if (platform.skipBrandFor && state.type && platform.skipBrandFor[state.type]) return false;
    var fbcounts = {};
    var fblabels = {};
    list.forEach(function (h) {
      var id = kind === 'gear'
        ? (h.gbrand || vendorBrandKey(h.vendor))
        : (h.fbrand || vendorBrandKey(h.vendor));
      if (!id) return;
      fbcounts[id] = (fbcounts[id] || 0) + 1;
      if (!fblabels[id]) fblabels[id] = opticBrandLabel(id, h.vendor);
    });
    var keys = Object.keys(fbcounts).filter(function (id) {
      return (fbcounts[id] || 0) >= 2;
    }).sort(function (a, b) {
      return String(fblabels[a] || a).localeCompare(String(fblabels[b] || b), undefined, { sensitivity: 'base' });
    });
    if (keys.length < 2) return false;
    var rows = keys.map(function (id) {
      var n = fbcounts[id];
      return { key: id, title: fblabels[id], sub: n + (n < STOP_AT ? ' — show products' : ' parts') };
    });
    var allLabel = state.type ? typeLabelOf(state.type).toLowerCase() : 'parts';
    rows.push({
      key: 'all',
      title: 'All ' + allLabel,
      sub: list.length + ' parts'
    });
    showRotateLayer(
      rows,
      function (key) {
        if (key === 'all') return list;
        return list.filter(function (h) {
          var id = kind === 'gear'
            ? (h.gbrand || vendorBrandKey(h.vendor))
            : (h.fbrand || vendorBrandKey(h.vendor));
          return id === key;
        });
      },
      function (s, key) { s.brand = key; },
      function (key) {
        state.brand = key;
        commit(true);
      }
    );
    return true;
  }

  function typeChipLabel(id) {
    if (kind === 'gear' && platform.lockedCat === 'optics') return gearTypeLabel('optics', id) || id;
    return typeLabelOf(id);
  }

  function opticBrandChipIds() {
    if (!(kind === 'gear' && platform.lockedCat === 'optics')) return [];
    var counts = {};
    var labels = {};
    items.forEach(function (h) {
      if (state.type && h.gtype !== state.type) return;
      var id = h.gbrand || vendorBrandKey(h.vendor);
      if (!id || id === 'other') return;
      counts[id] = (counts[id] || 0) + 1;
      if (!labels[id]) labels[id] = opticBrandLabel(id, h.vendor);
    });
    return Object.keys(counts).filter(function (id) {
      return counts[id] >= 2;
    }).sort(function (a, b) {
      return String(labels[a] || a).localeCompare(String(labels[b] || b), undefined, { sensitivity: 'base' });
    }).map(function (id) {
      return { id: id, label: labels[id] };
    });
  }

  function typeModelIds() {
    if (!hasModelStep()) return [];
    var counts = {};
    platform.models.forEach(function (id) { counts[id] = 0; });
    items.forEach(function (h) {
      if (state.type && h.ptype !== state.type) return;
      (h.models || []).forEach(function (id) {
        if (counts[id] !== undefined) counts[id] += 1;
      });
    });
    return platform.models.filter(function (id) { return counts[id] > 0; });
  }

  function clearProductQuick() {
    var wrap = wrapEl || document;
    var old = wrap.querySelectorAll('.gpc-product-quick');
    for (var i = 0; i < old.length; i++) old[i].remove();
  }

  function renderProductQuick() {
    if (!resultsEl) return;
    clearProductQuick();
    var types = typeChipRows();
    var models = typeModelIds();
    var brands = opticBrandChipIds();
    if (types.length < 2 && models.length < 2 && brands.length < 2) return;
    var html = '<div class="gpc-type-quick gpc-product-quick">';
    if (types.length >= 2) {
      html += '<div class="gpc-type-quick-row">';
      if (state.type) {
        html += '<button type="button" class="gpc-type-chip gpc-type-hit" data-ptype="all">All</button>';
      }
      types.forEach(function (t) {
        var on = state.type === t.id;
        html += '<button type="button" class="gpc-type-chip gpc-type-hit' + (on ? ' is-on' : '') + '" data-ptype="' + escAttr(t.id) + '"' +
          (on ? ' aria-current="true"' : '') + '>' + escHtml(typeChipLabel(t.id)) + '</button>';
      });
      html += '</div>';
    }
    if (models.length >= 2) {
      html += '<div class="gpc-type-quick-row">';
      if (state.model && state.model !== 'all') {
        html += '<button type="button" class="gpc-type-chip gpc-type-hit" data-model="all">All</button>';
      }
      models.forEach(function (id) {
        var on = state.model === id;
        html += '<button type="button" class="gpc-type-chip gpc-type-hit' + (on ? ' is-on' : '') + '" data-model="' + escAttr(id) + '"' +
          (on ? ' aria-current="true"' : '') + '>' + escHtml(firearmModelLabel(id)) + '</button>';
      });
      html += '</div>';
    }
    if (brands.length >= 2 && state.type) {
      html += '<div class="gpc-type-quick-row">';
      if (state.brand && state.brand !== 'all') {
        html += '<button type="button" class="gpc-type-chip gpc-type-hit" data-gbrand="all">All brands</button>';
      }
      brands.forEach(function (b) {
        var on = state.brand === b.id;
        html += '<button type="button" class="gpc-type-chip gpc-type-hit' + (on ? ' is-on' : '') + '" data-gbrand="' + escAttr(b.id) + '"' +
          (on ? ' aria-current="true"' : '') + '>' + escHtml(b.label) + '</button>';
      });
      html += '</div>';
    }
    html += '</div>';
    if (crumbsEl && crumbsEl.parentNode) crumbsEl.insertAdjacentHTML('afterend', html);
    else resultsEl.insertAdjacentHTML('afterbegin', html);
    var host = wrapEl || resultsEl;
    host.querySelectorAll('[data-ptype]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-ptype');
        state.type = id === 'all' ? null : id;
        state.brand = null;
        commit(true);
      });
    });
    host.querySelectorAll('[data-model]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state.model = btn.getAttribute('data-model');
        state.brand = null;
        commit(true);
      });
    });
    host.querySelectorAll('[data-gbrand]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-gbrand');
        state.brand = id === 'all' ? null : id;
        commit(true);
      });
    });
  }

  function showProducts(list, keepCap) {
    stopTypePreviewRotate();
    productPool = list || [];
    if (!keepCap) shownCap = PAGE_SIZE;
    var shown = productPool.filter(hitMatchesFacets).slice().sort(function (a, b) {
      var ao = a.inventory_available === false ? 1 : 0;
      var bo = b.inventory_available === false ? 1 : 0;
      if (ao !== bo) return ao - bo;
      if (state.sort === 'hi') return hitPrice(b) - hitPrice(a);
      if (state.sort === 'lo') return hitPrice(a) - hitPrice(b);
      return 0;
    });
    var page = shown.slice(0, shownCap);
    cardsEl.classList.add('hidden');
    resultsEl.classList.remove('hidden');
    if (!hasHeaderFilters()) renderProductQuick();
    else clearProductQuick();
    renderProductToolbar(productPool, shown);
    var productQ = productBrowseQuery();
    var emptyMsg = 'No matching parts.';
    if (!page.length && state.inStock && productPool.length) {
      emptyMsg = 'No in-stock parts. Turn off In stock only to see ' +
        productPool.length.toLocaleString('en-US') + ' out of stock.';
    }
    hitsEl.innerHTML = page.map(function (h) { return hitCard(h, productQ); }).join('') ||
      '<div class="col-span-full text-zinc-400 py-10 text-center">' + emptyMsg + '</div>';
    if (resultsEl && !resultsEl.getAttribute('data-gpc-more-bound')) {
      resultsEl.setAttribute('data-gpc-more-bound', '1');
      resultsEl.addEventListener('click', function (e) {
        var moreBtn = e.target.closest('[data-gpc-more]');
        if (!moreBtn) return;
        e.preventDefault();
        shownCap += PAGE_SIZE;
        showProducts(productPool, true);
      });
    }
    var more = resultsEl.querySelector('.gpc-show-more');
    if (more) more.remove();
    if (shown.length > page.length) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gpc-show-more';
      btn.setAttribute('data-gpc-more', '1');
      btn.textContent = 'Show more (' + (shown.length - page.length).toLocaleString('en-US') + ')';
      resultsEl.appendChild(btn);
    }
    renderOpticsTargetsTieIn();
  }

  function showCards(rows, onPick) {
    stopTypePreviewRotate();
    clearProductQuick();
    resultsEl.classList.add('hidden');
    cardsEl.classList.remove('hidden');
    cardsEl.innerHTML = '<div class="gpc-browse-grid gpc-home-rotates">' + rows.map(function (r) {
      return cardHtml(r.title, r.sub, r.key);
    }).join('') + '</div>';
    cardsEl.querySelectorAll('.gpc-browse-card').forEach(function (btn) {
      btn.addEventListener('click', function () { onPick(btn.getAttribute('data-key')); });
    });
  }

  function showRotateLayer(rows, hitsFor, hrefApply, onPick) {
    stopTypePreviewRotate();
    clearProductQuick();
    var previews = '';
    rows.forEach(function (r) {
      var bucket = hitsFor(r.key) || [];
      var hit = pickTypePreview(r.key, bucket);
      if (!hit) return;
      var href = previewHref(function (s) { hrefApply(s, r.key); });
      previews += typePreviewHtml(r, hit, href, bucket);
    });
    if (!previews) {
      showCards(rows, onPick);
      return;
    }
    resultsEl.classList.add('hidden');
    cardsEl.classList.remove('hidden');
    var chips = '';
    if (!hasHeaderFilters()) {
      chips = '<div class="gpc-type-quick"><div class="gpc-type-quick-row">' + rows.map(function (r) {
        return '<button type="button" class="gpc-type-chip gpc-type-hit" data-key="' + escAttr(r.key) + '">' +
          escHtml(r.title) + '</button>';
      }).join('') + '</div></div>';
    }
    cardsEl.innerHTML = chips +
      '<div class="gpc-type-previews gpc-home-rotates">' + previews + '</div>';
    cardsEl.querySelectorAll('[data-key]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        e.stopPropagation();
        onPick(btn.getAttribute('data-key'));
      });
    });
    startTypePreviewRotate();
    bindPreviewCaptions();
  }

  function showTypeLayer(typeRows, pool, onPick) {
    showRotateLayer(
      typeRows,
      function (key) {
        return pool.filter(function (h) { return h.ptype === key; });
      },
      function (s, key) {
        s.type = key;
        if (!hasHeaderFilters()) s.brand = null;
      },
      onPick
    );
  }

  function routeKnives() {
    if (!state.brand) {
      var counts = { all: items.length, other: 0 };
      KNIFE_BRANDS.forEach(function (b) { counts[b.id] = 0; });
      items.forEach(function (h) {
        if (counts[h.kbrand] !== undefined) counts[h.kbrand] += 1;
        else counts.other += 1;
      });
      var rows = KNIFE_BRANDS.filter(function (b) {
        return (counts[b.id] || 0) > 0;
      }).map(function (b) {
        var n = counts[b.id];
        return { key: b.id, title: b.label, sub: n + (n < STOP_AT ? ' — show products' : ' knives') };
      });
      rows.push({
        key: 'all',
        title: 'All knives',
        sub: counts.all + ' — including other brands'
      });
      showRotateLayer(
        rows,
        function (key) {
          if (key === 'all') return items;
          return items.filter(function (h) { return h.kbrand === key; });
        },
        function (s, key) {
          s.brand = key;
          s.series = null;
        },
        function (key) {
          state.brand = key;
          state.series = null;
          commit(true);
        }
      );
      return;
    }
    var list = items.filter(function (h) {
      if (state.brand && state.brand !== 'all' && h.kbrand !== state.brand) return false;
      if (state.series && state.series !== 'all' && h.kseries !== state.series) return false;
      return true;
    });
    var seriesRows = state.brand === 'spyderco' ? SPYDERCO_SERIES : (KNIFE_L2[state.brand] || []);
    if (!state.series && seriesRows.length && list.length >= STOP_AT) {
      var sc = {};
      seriesRows.forEach(function (s) { sc[s.id] = 0; });
      list.forEach(function (h) {
        if (h.kseries && sc[h.kseries] !== undefined) sc[h.kseries] += 1;
      });
      var srows = seriesRows.filter(function (s) {
        return (sc[s.id] || 0) >= TYPE_MIN;
      }).map(function (s) {
        var n = sc[s.id];
        return { key: s.id, title: s.label, sub: n + (n < STOP_AT ? ' — show products' : ' knives') };
      });
      if (srows.length >= 2) {
        srows.push({ key: 'all', title: 'All ' + knifeBrandLabel(state.brand), sub: list.length + ' knives' });
        showRotateLayer(
          srows,
          function (key) {
            if (key === 'all') return list;
            return list.filter(function (h) { return h.kseries === key; });
          },
          function (s, key) { s.series = key; },
          function (key) {
            state.series = key;
            commit(true);
          }
        );
        return;
      }
    }
    showProducts(list);
  }

  function routeGear() {
    if (!state.cat) {
      var counts = {};
      GEAR_CATS.forEach(function (c) { counts[c.id] = 0; });
      items.forEach(function (h) {
        if (counts[h.gcat] !== undefined) counts[h.gcat] += 1;
      });
      var rows = GEAR_CATS.filter(function (c) {
        if (c.skipOnGear && !platform.lockedCat) return false;
        return (counts[c.id] || 0) > 0;
      }).map(function (c) {
        var n = counts[c.id];
        return { key: c.id, title: c.label, sub: n + (n < STOP_AT ? ' — show products' : ' products') };
      });
      showRotateLayer(
        rows,
        function (key) {
          return items.filter(function (h) { return h.gcat === key; });
        },
        function (s, key) {
          s.cat = key;
          s.type = null;
        },
        function (key) {
          state.cat = key;
          state.type = null;
          commit(true);
        }
      );
      return;
    }
    var cat = GEAR_CATS.filter(function (c) { return c.id === state.cat; })[0];
    var list = items.filter(function (h) {
      if (h.gcat !== state.cat) return false;
      if (state.type === 'hearing') {
        if (h.gtype !== 'over-ear-elec' && h.gtype !== 'over-ear-passive' && h.gtype !== 'in-ear') return false;
      } else if (state.type === 'over-ear') {
        if (h.gtype !== 'over-ear-elec' && h.gtype !== 'over-ear-passive') return false;
      } else if (state.type && h.gtype !== state.type) {
        return false;
      }
      if (state.brand && state.brand !== 'all') {
        var gb = h.gbrand || vendorBrandKey(h.vendor);
        if (gb !== state.brand) return false;
      }
      if (state.series && state.series !== 'all' && h.gseries !== state.series) return false;
      return true;
    });
    if (!cat || list.length < STOP_AT) {
      showProducts(list);
      return;
    }
    if (platform.quickTypes) {
      showProducts(list);
      return;
    }
    if (!cat.skipL2 && !state.type && cat.l2 && cat.l2.length) {
      var tc = {};
      cat.l2.forEach(function (t) { tc[t.id] = 0; });
      list.forEach(function (h) {
        if (tc[h.gtype] !== undefined) tc[h.gtype] += 1;
      });
      var trows = cat.l2.filter(function (t) {
        var n = tc[t.id] || 0;
        if (!n) return false;
        return n >= TYPE_MIN || t.id === 'other';
      }).map(function (t) {
        var n = tc[t.id];
        return { key: t.id, title: t.label, sub: n + (n < STOP_AT ? ' — show products' : ' products') };
      });
      if (trows.length >= 2) {
        showRotateLayer(
          trows,
          function (key) {
            return list.filter(function (h) { return h.gtype === key; });
          },
          function (s, key) {
            s.type = key;
            s.brand = null;
            s.series = null;
          },
          function (key) {
            state.type = key;
            state.brand = null;
            state.series = null;
            commit(true);
          }
        );
        return;
      }
    }
    if (!state.brand && wantsBrand(cat, state.type)) {
      var bcounts = {};
      var blabels = {};
      list.forEach(function (h) {
        var id = h.gbrand || vendorBrandKey(h.vendor);
        bcounts[id] = (bcounts[id] || 0) + 1;
        if (!blabels[id]) blabels[id] = opticBrandLabel(id, h.vendor);
      });
      var typeDef = {};
      if (cat.l2 && state.type) {
        typeDef = cat.l2.filter(function (x) { return x.id === state.type; })[0] || {};
      }
      var coreBrands = typeDef.coreBrands || cat.coreBrands || {};
      var bkeys = Object.keys(bcounts).filter(function (id) {
        var n = bcounts[id] || 0;
        if (!n) return false;
        if (coreBrands[id]) return true;
        return n >= TYPE_MIN;
      }).sort(function (a, b) {
        return String(blabels[a] || a).localeCompare(String(blabels[b] || b), undefined, { sensitivity: 'base' });
      });
      if (bkeys.length >= 2) {
        var brows = bkeys.map(function (id) {
          var n = bcounts[id];
          return { key: id, title: blabels[id], sub: n + (n < STOP_AT ? ' — show products' : ' products') };
        });
        var allLabel = gearTypeLabel(state.cat, state.type);
        if (!state.type || allLabel === state.type) allLabel = cat.label;
        var allTitle = state.type === 'red-dots' ? 'All red dots' : 'All ' + String(allLabel).toLowerCase();
        brows.push({ key: 'all', title: allTitle, sub: list.length + ' products' });
        showRotateLayer(
          brows,
          function (key) {
            if (key === 'all') return list;
            return list.filter(function (h) {
              return (h.gbrand || vendorBrandKey(h.vendor)) === key;
            });
          },
          function (s, key) {
            s.brand = key;
            s.series = null;
          },
          function (key) {
            state.brand = key;
            state.series = null;
            commit(true);
          }
        );
        return;
      }
    }
    if (state.brand && state.brand !== 'all' && !state.series && state.type === 'scopes') {
      var seriesRows = OPTIC_SERIES[state.brand] || [];
      if (seriesRows.length && list.length >= 80) {
        var scounts = {};
        seriesRows.forEach(function (s) { scounts[s.id] = 0; });
        scounts.other = 0;
        list.forEach(function (h) {
          var sid = h.gseries || 'other';
          if (scounts[sid] === undefined) scounts.other += 1;
          else scounts[sid] += 1;
        });
        var srows = seriesRows.filter(function (s) {
          return (scounts[s.id] || 0) >= TYPE_MIN;
        }).map(function (s) {
          var n = scounts[s.id];
          return { key: s.id, title: s.label, sub: n + (n < STOP_AT ? ' — show products' : ' products') };
        });
        if ((scounts.other || 0) >= TYPE_MIN) {
          srows.push({
            key: 'other',
            title: 'Other ' + opticBrandLabel(state.brand),
            sub: scounts.other + ' products'
          });
        }
        if (srows.length >= 2) {
          srows.push({
            key: 'all',
            title: 'All ' + opticBrandLabel(state.brand),
            sub: list.length + ' products'
          });
          showRotateLayer(
            srows,
            function (key) {
              if (key === 'all') return list;
              return list.filter(function (h) {
                var sid = h.gseries || 'other';
                return sid === key;
              });
            },
            function (s, key) { s.series = key; },
            function (key) {
              state.series = key;
              commit(true);
            }
          );
          return;
        }
      }
    }
    // Brand product page: show that brand across optic types so Red dots /
    // Scopes / Magnifiers can filter in-place (EOTech Vudu + G33 live here).
    if (state.brand && state.brand !== 'all' && !state.series && state.cat === 'optics') {
      list = items.filter(function (h) {
        if (h.gcat !== state.cat) return false;
        return (h.gbrand || vendorBrandKey(h.vendor)) === state.brand;
      });
    }
    if (showBrandLayer(list)) return;
    showProducts(list);
  }

  function paintFromSnapshot() {
    if (!indexPlat) {
      setStatus('Loading catalog…');
      return;
    }
    function pick(apply) {
      return function (key) {
        apply(key);
        commit(true);
      };
    }
    if (kind === 'knives' && !state.brand) {
      setStatus('');
      showCards((indexPlat.brands || []).map(function (b) {
        return { key: b.id, title: b.label, sub: b.n + ' knives' };
      }), pick(function (key) { state.brand = key; }));
      return;
    }
    if (kind === 'gear') {
      if (!platform.lockedCat && !state.cat) {
        setStatus('');
        showCards((indexPlat.cats || []).map(function (b) {
          return { key: b.id, title: b.label, sub: b.n + ' parts' };
        }), pick(function (key) {
          state.cat = key;
          state.type = null;
          state.brand = null;
        }));
        return;
      }
      if (!state.type) {
        setStatus('');
        showCards((indexPlat.types || []).map(function (b) {
          return { key: b.id, title: b.label, sub: b.n + (b.n < STOP_AT ? ' — show products' : ' parts') };
        }), pick(function (key) {
          state.type = key;
          state.brand = null;
        }));
        return;
      }
      setStatus('Loading catalog…');
      return;
    }
    if (hasModelStep() && !state.model && !state.type) {
      setStatus('');
      var rows = (indexPlat.models || []).map(function (b) {
        return { key: b.id, title: b.label, sub: b.n + ' parts' };
      });
      rows.push({
        key: 'all',
        title: 'All ' + platform.name,
        sub: (indexPlat.n || 0) + ' parts — including unlisted models'
      });
      showCards(rows, pick(function (key) {
        state.model = key;
        state.type = null;
        state.brand = null;
      }));
      return;
    }
    if (!state.type) {
      var snapTypes = snapshotTypeRows();
      if (state.model && state.model !== 'all' &&
          !(indexPlat.typesByModel && indexPlat.typesByModel[state.model])) {
        setStatus('Loading catalog…');
        return;
      }
      setStatus('');
      showCards(snapTypes.map(function (b) {
        return { key: b.id, title: b.label, sub: b.n + (b.n < STOP_AT ? ' — show products' : ' parts') };
      }), pick(function (key) {
        state.type = key;
        state.brand = null;
      }));
      return;
    }
    setStatus('Loading catalog…');
  }

  function loadBrowseIndex() {
    var url = (typeof window !== 'undefined' && window.GPC && window.GPC.browseIndexUrl) || '';
    if (!url || !handle) return;
    fetch(url, { credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (data) {
      if (!data || !data.platforms || !data.platforms[handle]) return;
      indexPlat = data.platforms[handle];
      if (!items.length) route();
    }).catch(function () {});
  }

  function route() {
    if (handle === 'parts') attachPartsModels();
    renderCrumbs();
    renderBack();
    syncBrowseChrome();
    if (hasHeaderFilters()) renderHeaderFilters();
    if (!items.length) {
      paintFromSnapshot();
      return;
    }
    if (kind === 'knives') {
      routeKnives();
      return;
    }
    if (kind === 'gear') {
      routeGear();
      return;
    }
    var list;
    var hasModels = platform.models && platform.models.length;
    if (hasHeaderFilters()) {
      list = filtered();
      if (!state.type) {
        var hTypeRows = typeLayerRows(list);
        if (hTypeRows.length >= 2) {
          showTypeLayer(hTypeRows, list, function (key) {
            state.type = key;
            commit(true);
          });
          return;
        }
        showProducts(list);
        return;
      }
      // Type is already chosen (header dropdown or a shop deep-link like
      // ?model=17&type=triggers). Show the product grid. Brand stays a
      // header filter — do not intercept with another mosaic.
      showProducts(list);
      return;
    }
    if (hasModels && !state.model) {
      var counts = { all: items.length };
      platform.models.forEach(function (id) { counts[id] = 0; });
      items.forEach(function (h) {
        h.models.forEach(function (id) { if (counts[id] !== undefined) counts[id] += 1; });
      });
      var rows = platform.models.filter(function (id) { return counts[id] > 0; }).map(function (id) {
        return { key: id, title: firearmModelLabel(id), sub: counts[id] + ' parts' };
      });
      rows.push({ key: 'all', title: 'All ' + platform.name, sub: counts.all + ' parts — including unlisted models' });
      showRotateLayer(
        rows,
        function (key) {
          if (key === 'all') return items;
          return items.filter(function (h) { return h.models.indexOf(key) !== -1; });
        },
        function (s, key) {
          s.model = key;
          s.type = null;
          s.brand = null;
        },
        function (key) {
          state.model = key;
          state.type = null;
          state.brand = null;
          commit(true);
        }
      );
      return;
    }

    list = filtered();
    if (platform.quickTypes && state.model) {
      showProducts(list);
      return;
    }
    if (hasModels && state.model === 'all') {
      showProducts(list);
      return;
    }
    if (list.length < STOP_AT) {
      showProducts(list);
      return;
    }
    if (!state.type) {
      var typeRows = typeLayerRows(list);
      showTypeLayer(typeRows, list, function (key) {
        state.type = key;
        state.brand = null;
        commit(true);
      });
      return;
    }
    if (showBrandLayer(list)) return;
    showProducts(list);
  }

  function loadCatalog() {
    var queries = catalogQueries();
    if (!queries.length) {
      items = [];
      loadedKey = catalogKey();
      route();
      return;
    }
    var loadId = ++catalogLoadId;
    setStatus('Loading parts…');
    items = [];
    Promise.all(queries.map(browseQuery)).then(function (sets) {
    if (loadId !== catalogLoadId) return;
    var seen = {};
    stopTypePreviewRotate();
    typePreviewPools = {};
    typePreviewIndex = {};
    sets.forEach(function (arr) {
      arr.forEach(function (h) {
        try {
        ingestOneHit(h, seen);
        } catch (err) {
          if (typeof console !== 'undefined' && console.error) console.error('gpc browse ingest', h && h.objectID, err);
        }
      });
    });
    loadedKey = catalogKey();
    setStatus('');
    history.replaceState({ gpcBrowse: true, gpcDepth: depth() }, '', browsePath());
    lastTrackedPath = browsePath();
    route();
  }).catch(function (err) {
    if (typeof console !== 'undefined' && console.error) console.error('gpc browse', err);
    setStatus('Could not load this catalog. Use search in the header.');
  });
  }

  function ingestOneHit(h, seen) {
        var id = h.objectID;
        if (seen[id]) return;
        if (C.restrictedOf && C.restrictedOf(h.title, h.vendor, h.body_html_safe, { product_type: h.product_type })) return;
        var blob = (h.title || '') + ' ' + (h.vendor || '');
        if (kind === 'knives') {
          var k = knifeClassify(h.title, h.vendor);
          if (!k) return;
          seen[id] = 1;
          h.kbrand = k.brand;
          h.kseries = k.series;
          h.bladeIn = (window.gpcBladeInches && window.gpcBladeInches(h.title, h.body_html_safe)) || null;
          items.push(h);
          return;
        }
        if (kind === 'gear') {
          var g = gearClassify(h.title, h.vendor);
          if (!g) return;
          if (platform.lockedCat) {
            if (g.cat !== platform.lockedCat) return;
          } else if (g.cat === 'optics') {
            if (g.type !== 'spotting' && g.type !== 'binoculars') return;
            g = { cat: 'range', type: g.type };
          }
          if (state.cat && !platform.lockedCat && g.cat !== state.cat) return;
          if (state.type && g.type !== state.type) {
            if (!(state.type === 'hearing' && (g.type === 'over-ear-elec' || g.type === 'over-ear-passive' || g.type === 'in-ear'))) return;
          }
          seen[id] = 1;
          h.gcat = g.cat;
          h.gtype = g.type;
          h.gbrand = vendorBrandKey(h.vendor);
          h.gseries = opticSeriesOf(String(h.title || '').toUpperCase(), h.gbrand);
          items.push(h);
          if (g.cat === 'gloves' && isNitrileGlove(String(h.title || '').toUpperCase())) {
            var cleanCopy = {};
            Object.keys(h).forEach(function (k) { cleanCopy[k] = h[k]; });
            cleanCopy.gcat = 'cleaning';
            cleanCopy.gtype = 'gloves';
            items.push(cleanCopy);
          }
          return;
        }
        if (platform.exclude && platform.exclude.test(blob)) return;
        if (skipFirearmFamily && skipFirearmFamily(h.title, h.vendor)) return;
        if (isCleanHit(String(h.title || '').toUpperCase(), String(h.vendor || '').toUpperCase())) return;
        var inFam = platform.family ? platform.family.test(blob) : false;
        if (handle === 'hk') inFam = isHk(h.title, h.vendor, h.body_html_safe);
        if (handle === 'remington') inFam = isRemingtonFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'beretta') inFam = isBerettaFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'colt') inFam = isColtFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'glock') inFam = isGlock(h.title, h.vendor, h.body_html_safe);
        if (handle === 'mossberg') inFam = isMossbergFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'ruger') inFam = isRugerFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'sig-sauer') inFam = isSigFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'springfield') inFam = isSpringfieldFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'smith-wesson') inFam = isSwFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'taurus') inFam = isTaurusFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'cz') inFam = isCzFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'walther') inFam = isWaltherFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'benelli') inFam = isBenelliFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'bersa') inFam = isBersaFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'browning') inFam = isBrowningFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'canik') inFam = isCanikFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'cmmg') inFam = isCmmgFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'fn') inFam = isFnFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'henry') inFam = isHenryFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'iwi') inFam = isIwiFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'kahr') inFam = isKahrFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'kel-tec') inFam = isKeltecFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'kimber') inFam = isKimberFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'savage') inFam = isSavageFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'tikka') inFam = isTikkaFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'marlin') inFam = isMarlinFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === '1911') inFam = is1911Firearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'ar-15') inFam = isAr15Firearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'ak-47') inFam = isAkFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === '10-22') inFam = is1022Firearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'ar-10') inFam = isAr10Firearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'airguns') inFam = isAirgunFirearm(h.title, h.vendor, h.body_html_safe);
        if (handle === 'parts') inFam = isPartsHit(h.title, h.vendor, h.body_html_safe);
        if (!inFam && handle !== 'remington' && handle !== 'ruger' && handle !== 'sig-sauer' && handle !== 'springfield' && handle !== 'smith-wesson' && handle !== 'taurus' && handle !== 'cz' && handle !== 'walther' && handle !== 'benelli' && handle !== 'bersa' && handle !== 'browning' && handle !== 'canik' && handle !== 'cmmg' && handle !== 'fn' && handle !== 'henry' && handle !== 'iwi' && handle !== 'kahr' && handle !== 'kel-tec' && handle !== 'kimber' && handle !== 'savage' && handle !== 'tikka' && handle !== 'marlin' && handle !== '1911' && handle !== 'ar-15' && handle !== 'ak-47' && handle !== '10-22' && handle !== 'ar-10' && handle !== 'airguns' && handle !== 'parts') inFam = promagFitsPlatform(h.title, h.vendor, h.body_html_safe, platform);
        if (!inFam) return;
        if (knifeClassify(h.title, h.vendor)) return;
        seen[id] = 1;
        h.models = modelsOf(h.title, platform, h.body_html_safe, h.vendor);
        h.ptype = partType(h.title, h.vendor, h.body_html_safe);
        if (platform.hideTypes && platform.hideTypes[h.ptype]) h.ptype = 'other';
        if (platform.mergeTypes && platform.mergeTypes[h.ptype]) h.ptype = platform.mergeTypes[h.ptype];
        if (!loadFamilyHits() && state.type && h.ptype !== state.type) return;
        h.fbrand = vendorBrandKey(h.vendor);
        h.guns = (handle === 'parts' && gunFamiliesOf)
          ? gunFamiliesOf(h.title, h.vendor, h.body_html_safe)
          : [];
        h.gens = ((handle === 'glock' || (h.guns && h.guns.indexOf('glock') !== -1)) && glockGensOf)
          ? glockGensOf(h.title, h.body_html_safe)
          : [];
        h.modelsByGun = {};
        items.push(h);
  }

  function attachPartsModels() {
    if (handle !== 'parts' || !state.gun) return;
    var gplat = PLATFORMS[state.gun];
    if (!gplat || !gplat.models || !gplat.models.length) return;
    items.forEach(function (h) {
      if (!h.guns || h.guns.indexOf(state.gun) === -1) return;
      h.modelsByGun = h.modelsByGun || {};
      if (h.modelsByGun[state.gun]) return;
      var mods = modelsOf(h.title, gplat, h.body_html_safe, h.vendor);
      if (mods && mods.length) h.modelsByGun[state.gun] = mods;
    });
  }

  function ensureCatalog() {
    var need = catalogKey();
    if (need === loadedKey) {
      route();
      return;
    }
    loadCatalog();
  }

  if (typeof window !== 'undefined' && cardsEl) {
    syncBrowseChrome();
    loadBrowseIndex();
    ensureCatalog();
  }
})();
